<template>
  <div id="scheduleRootDiv">
    <!-- 해당 템플릿에서 v-if="width < 2054 && width > 1699" 이 부분은 크기가 1699이하로 작아지면 사라지게 만든 코드입니다. -->
    <!-- <template v-if="width < 2054 && width > 1699"> -->
    <!-- 아래 탬플릿으로 변경 2023-04-12 -->
    <template>
      <vs-row justify="flex-end">
        <vs-col :key="index" v-for="(col, index) in 3" w="2"><br /></vs-col>
        <div class="vx-row mb-3">
          <div class="vx-row" style="margin-left: 15px; margin-bottom: 20px">
            <v-select
              id="searchBar"
              class="searchPatient"
              name="search"
              style="width: 400px"
              :maxHeight="'50px'"
              ref="searchInput"
              label="label"
              placeholder="환자 이름 or 전화번호 or 차트번호 입력 후 엔터(Enter)"
              :options="patientList"
              :filterable="false"
              v-model="search"
              @input="applyPatientId"
            />
            <!-- <div class="w-row" ref="dropdownDiv" style="width: 450px;">
                        <vs-input
                            class="w-full"
                            
                            icon="search"
                            placeholder="환자 이름 or 전화번호 or 차트번호 입력 후 엔터(Enter)"
                            v-model="search"
                            @keyup.enter="searchPatient"
                        />
                        <div class="w-full lg color.black" style="display: none;" ref="patientDropDown">
                            <div id="drop-content">
                                <template v-for="(item, index) in searchPatientList">
                                        <a href="#" class="w-row" :key="index" >{{ item.label }}</a>
                                </template>
                            </div>
                        </div>

                      </div> -->

            <!-- <button
              type="button"
              ref="searchBtn"
              name="button"
              class="vs-component vs-button ml-1 vs-button-primary vs-button-filled"
              @click="applyPatientId"
              @keyup.enter="applyPatientId"
            >
              <span
                class="vs-button-backgroundx vs-button--background"
                style="
                  opacity: 1;
                  left: 20px;
                  top: 20px;
                  width: 0px;
                  height: 0px;
                  transition: width 0.3s ease 0s, height 0.3s ease 0s,
                    opacity 0.3s ease 0s;
                "
              ></span>
              <span class="vs-button-text vs-button--text">조회</span>
              <span
                class="vs-button-linex"
                style="top: auto; bottom: -2px; left: 50%; transform: translate(-50%)"
              ></span>
            </button> -->
          </div>
        </div>
      </vs-row>
    </template>
    <div class="vx-row">
      <div class="vx-col w-full lg:w-1/5 mb-base">
        <vx-card class="p-2">
          <div class="text-center">
            <p class="text-grey">#{{ chart_no }}</p>
            <h4>{{ patientUsername }}({{ status_name }})</h4>
            <p class="text-grey">{{ patientAge }}, {{ patientGender }}</p>
            <p class="text-grey">{{ patient_phone }}</p>
            <p class="" style="color: #fc4545;">{{ inLongTerm == 'Y' ? '장기미내원환자' : '' }}</p>
          </div>
          <vs-divider></vs-divider>>
          <div class="flex justify-between text-center">
            <span>
              <p class="font-semibold">
                {{ medicalRoomNm }}({{ medicalRoomNumberNm }}-{{ nextCD }})
              </p>
              <small class="text-grey">병동(호실-베드위치)</small>
            </span>
            <span>
              <p class="font-semibold">{{ medicalName }}</p>
              <small class="text-grey">본 병원</small>
            </span>
            <span>
              <p class="font-semibold">{{ sickNess }}</p>
              <small class="text-grey">병명</small>
            </span>
          </div>
          <vs-divider></vs-divider>
          <div class="my-6">
            <h5 class="mb-2">치료플랜</h5>
            <p class="plan_text">
              <template v-if="plan == null || plan == 0">작성한 치료플랜 없음</template>
              <template v-else>{{ plan }}</template>
            </p>
          </div>
          <vs-divider></vs-divider>
          <table style="width: 100%" class="border-collapse calendar">
            <colgroup>
              <col width="40%" />
              <col width="60%" />
            </colgroup>

            <tbody>
              <tr>
                <th
                  class="p-2 border border-solid d-theme-border-grey-light text-center table_header"
                >
                  최초입원일
                </th>
                <td class="border border-solid d-theme-border-grey-light">
                  {{ in_init_date }}
                </td>
              </tr>
              <tr>
                <th
                  class="p-2 border border-solid d-theme-border-grey-light text-center table_header"
                >
                  입원일
                </th>
                <td class="border border-solid d-theme-border-grey-light">
                  {{ in_date }}
                </td>
              </tr>
              <tr>
                <th
                  class="p-2 border border-solid d-theme-border-grey-light text-center table_header"
                >
                  퇴원예정일
                </th>
                <td class="border border-solid d-theme-border-grey-light">
                  {{ out_date }}
                </td>
              </tr>
              <tr>
                <th
                  class="p-2 border border-solid d-theme-border-grey-light text-center table_header"
                >
                  왼퇴여부
                </th>
                <td class="border border-solid d-theme-border-grey-light">
                  {{ complate_yn }}
                </td>
              </tr>
              <tr>
                <th
                  class="p-2 border border-solid d-theme-border-grey-light text-center table_header"
                >
                  식이
                </th>
                <td class="border border-solid d-theme-border-grey-light">
                  {{ meal_name }}
                </td>
              </tr>
              <tr>
                <th
                  class="p-2 border border-solid d-theme-border-grey-light text-center table_header"
                >
                  환자연락처
                </th>
                <td class="border border-solid d-theme-border-grey-light">
                  {{ patient_phone }}
                </td>
              </tr>
              <tr>
                <th
                  class="p-2 border border-solid d-theme-border-grey-light text-center table_header"
                >
                  보호자
                </th>
                <td class="border border-solid d-theme-border-grey-light">
                  {{ protector_phone }}
                </td>
              </tr>
              <tr>
                <th
                  class="p-2 border border-solid d-theme-border-grey-light text-center table_header"
                >
                  한방주치의
                </th>
                <td class="border border-solid d-theme-border-grey-light">
                  {{ medical_nm }}
                </td>
              </tr>
              <tr>
                <th
                  class="p-2 border border-solid d-theme-border-grey-light text-center table_header"
                >
                  양방주치의
                </th>
                <td class="border border-solid d-theme-border-grey-light">
                  {{ west_medical_nm }}
                </td>
              </tr>
              <tr>
                <th
                  class="p-2 border border-solid d-theme-border-grey-light text-center table_header"
                >
                  병동주치의
                </th>
                <td class="border border-solid d-theme-border-grey-light">
                  {{ consultDoctor }}
                </td>
              </tr>
            </tbody>
          </table>

          <div class="my-6">
            <h5 class="mb-2">컴플레인</h5>
            <vs-textarea
              placeholder="자유롭게 작성 후 저장버튼 클릭."
              height="200px"
              v-model="memo"
            />
          </div>

          <vs-button
            type="gradient"
            class="w-full mt-6"
            color="#7367F0"
            gradient-color-secondary="#CE9FFC"
            @click="patientMemoSave"
            >저장</vs-button
          >
        </vx-card>
      </div>
      <div class="vx-col w-full lg:w-4/5 mb-base" id="scheduleCalendar">
        <vx-card title="스케줄 관리">
          <div class="vx-col w-full xl:w-1/1 mb-base">
            <vs-button
              type="gradient"
              class="mt-6"
              color="#7367F0"
              gradient-color-secondary="#CE9FFC"
              @click="$router.push('/patientSchedule/scheduleList/' + patient_member_uid)"
              >리스트 스케줄 보기</vs-button
            >
            <div class="flex justify-end flex-wrap mb-3">
                <!--
              <a
                :href="
                  '/api/patientCalendar/calendarExcel/' +
                  patient_member_uid +
                  '?year_month=' +
                  now_date
                "
                download="download"
                >
                <vs-button size="small">엑셀다운로드</vs-button>
                </a>
                -->
                <vs-button @click="printCalendar()" size="small" class="mr-2">프린트</vs-button>
                
                <!-- 다중 복사 버튼 -->
                <vx-tooltip text="다중복사" position="top" class="ml-3">
                    <vs-button 
                        radius 
                        color="success" 
                        icon-pack="feather" 
                        icon="icon-layers"
                        @click="openMultiCopyModal"
                        :disabled="!isMultiCopyEnabled"
                    />
                </vx-tooltip>
            </div>

            <div class="text-right">
              <!-- <vx-tooltip text="수정" position="top"> -->
              <vs-button
                color="primary"
                type="line"
                icon-pack="feather"
                icon="icon-user"
                @click="popupOpen('02')"
              />
              <vs-button
                color="primary"
                type="line"
                icon-pack="feather"
                icon="icon-home"
                @click="popupOpen('01')"
              />
              <vs-button
                color="primary"
                type="line"
                icon-pack="feather"
                icon="icon-truck"
                @click="popupOpen('03')"
              />
              <vs-button
                color="primary"
                type="line"
                icon-pack="feather"
                icon="icon-edit-2"
                @click="onClickMemberView('patient')"
              />
              <vs-button
                color="primary"
                type="line"
                icon-pack="feather"
                icon="icon-headphones"
                @click="onClickMemberView('cs')"
              />
              <vs-button color="primary" type="line" icon-pack="feather" icon="icon-message-circle" v-show="tab_sum & 1024"
                      @click="onClickKakao()" />
              <!-- </vx-tooltip> -->
            </div>
          </div>
        <div id="printArea" style="width: 100%; overflow: auto" class="content">
          <div class="vx-row printPatientInfo" style="display:none;">
            <div class="vx-col w-full xl:w-1/1 mb-base text-center">
              <h1>{{ medicalRoomNumberNm }}) {{ patientUsername }}</h1>
            </div>
          </div>
          <div class="vx-row w-full xl:w-1/1 mb-base text-center">
            <div class="vx-col w-full xl:w-1/1 mb-base text-center">
              <div class="flex items-center">
                <vs-button
                  color="primary"
                  type="border"
                  icon-pack="feather"
                  icon="icon-chevron-left"
                  @click="prevMonth"
                />
                <date-picker
                  id="datepicker-component"
                  v-model="nowDate"
                  @change="updateDate"
                  type="month"
                  :lang="{
                    formatLocale: {
                      firstDayOfWeek: 1,
                      months: ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'],
                      monthsShort: ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월']
                    },
                    yearFormat: 'YYYY년',
                    monthFormat: 'M월',
                    monthBeforeYear: false
                  }"
                  value-type="format"
                  format="YYYYMM"
                  class="inline-block mx-2"
                />
                <vs-button
                  color="primary"
                  type="border"
                  icon-pack="feather"
                  icon="icon-chevron-right"
                  @click="nextMonth"
                />
              </div>
              <!--<span class="ml-5 mr-5">{{ displayDate }}</span>-->
              <div class="text-right n-content" style="margin-right: 0; padding-right: -10%;">
                <vs-button
                  class="primary small"
                  type="line"
                  icon-pack="feather"
                  icon="icon-circle"
                >대기</vs-button>
                <vs-button
                  color="success"
                  class="small"
                  type="line"
                  icon-pack="feather"
                  icon="icon-circle"
                >정상</vs-button>
                <vs-button
                  color="warning"
                  class="small"
                  type="line"
                  icon-pack="feather"
                  icon="icon-circle"
                >외래</vs-button>
                <vs-button
                  color="danger"
                  class="small"
                  type="line"
                  icon-pack="feather"
                  icon="icon-circle"
                >외진</vs-button>
              </div>
            </div>
          </div>
          <div style="width: 100%; overflow: auto" class="content">
            <table
              style="width: 100%; min-width: 1200px"
              class="border-collapse calendar"
            >
              <colgroup>
                <col width="14%" />
                <col width="14%" />
                <col width="14%" />
                <col width="14%" />
                <col width="14%" />
                <col width="14%" />
                <col width="14%" />
              </colgroup>
              <thead>
                <tr>
                  <th
                    class="p-2 border border-solid d-theme-border-grey-light text-center table_header"
                  >
                    일
                  </th>
                  <th
                    class="p-2 border border-solid d-theme-border-grey-light text-center table_header"
                  >
                    월
                  </th>
                  <th
                    class="p-2 border border-solid d-theme-border-grey-light text-center table_header"
                  >
                    화
                  </th>
                  <th
                    class="p-2 border border-solid d-theme-border-grey-light text-center table_header"
                  >
                    수
                  </th>
                  <th
                    class="p-2 border border-solid d-theme-border-grey-light text-center table_header"
                  >
                    목
                  </th>
                  <th
                    class="p-2 border border-solid d-theme-border-grey-light text-center table_header"
                  >
                    금
                  </th>
                  <th
                    class="p-2 border border-solid d-theme-border-grey-light text-center table_header"
                  >
                    토
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in mergedCalendarData" :key="index">
                  <td
                    class="border border-solid d-theme-border-grey-light"
                    :class="returnDay(item.Sun)"
                  >
                    <div class="day">
                      <div class="days_left sun">{{ dayReturn(item.Sun) }}</div>
                      <div class="days_right">
                        <vs-button
                          class="n-content"
                          radius
                          color="dark"
                          type="line"
                          icon-pack="feather"
                          icon="icon-copy"
                          v-if="dayReturn(item.Sun) != ''"
                          @click="clipCopyConfirm(item.YM, item.Sun)"
                        ></vs-button>
                        <!-- <vs-button
                                                    radius
                                                    color="dark"
                                                    type="line"
                                                    icon-pack="feather"
                                                    icon="icon-plus"
                                                    v-if="dayReturn(item.Sun) != ''"
                                                    @click="calendarTdClick(item.YM, item.Sun, index, 0)"
                                                ></vs-button> -->
                        <vs-button
                        class="n-content"
                          radius
                          color="dark"
                          type="line"
                          icon-pack="feather"
                          icon="icon-user"
                          v-if="dayReturn(item.Sun) != ''"
                          @click="
                            [applyDateOnPopup(item, dayReturn(item.Sun)), popupOpen('02')]
                          "
                        />
                        <vs-button
                        class="n-content"
                          radius
                          color="dark"
                          type="line"
                          icon-pack="feather"
                          icon="icon-home"
                          v-if="dayReturn(item.Sun) != ''"
                          @click="
                            [applyDateOnPopup(item, dayReturn(item.Sun)), popupOpen('01')]
                          "
                        />
                        <vs-button
                        class="n-content"
                          radius
                          color="dark"
                          type="line"
                          icon-pack="feather"
                          icon="icon-truck"
                          v-if="dayReturn(item.Sun) != ''"
                          @click="
                            [applyDateOnPopup(item, dayReturn(item.Sun)), popupOpen('03')]
                          "
                        />
                      </div>
                    </div>
                    <div class="dayContents " v-bind:id="'calendar_td_' + item.Sun">
                      <template v-if="checkEtcScheduleDate('f/u', dayReturn(item.Sun))">
                        <vs-chip v-bind:color="etcScheduleColor('f/u')" class="w-full n-content">
                          F/U
                        </vs-chip>
                      </template>
                      <template
                        v-if="checkEtcScheduleDate('inspection', dayReturn(item.Sun))"
                        
                      >
                        <vs-chip
                          v-bind:color="etcScheduleColor('inspection')"
                          class="w-full n-content"
                        >
                          검사
                        </vs-chip>
                      </template>
                      <template
                        v-if="checkEtcScheduleDate('indemStdt', dayReturn(item.Sun))"
                      >
                        <vs-chip
                          v-bind:color="etcScheduleColor('indemStdt')"
                          class="w-full n-content"
                        >
                          면책시작일
                        </vs-chip>
                      </template>
                      <template
                        v-if="checkEtcScheduleDate('indemEnddt', dayReturn(item.Sun))"
                      >
                        <vs-chip
                          v-bind:color="etcScheduleColor('indemEnddt')"
                          class="w-full n-content"
                        >
                          면책종료일
                        </vs-chip>
                      </template>
                      <template v-if="returnScheduleArr(item.Sun) != '' ">
                        <vs-chip
                          v-bind:color="returnValueClass(td_item)"
                          class="w-full v-content"
                          v-for="(td_item, td_index) in returnScheduleArr(item.Sun)"
                          :key="td_index"
                          v-show="return_schedule_id(td_item) != ''"
                        >
                          <input
                            type="checkbox"
                            v-model="copyChecked"
                            v-show="return_schedule_id(td_item).substring(0,2) != '05'"
                            class="n-content"
                            :value="return_schedule_seq(td_item)"
                          />
                          <span
                            :style="
                              returnDcYn(td_item) == 'Y'
                                ? 'text-decoration:line-through'
                                : ''
                            "
                            v-html="returnValueName(td_item)"
                          ></span>
                          <a
                            href="#"
                            class="n-content"
                            v-show="return_schedule_id(td_item).substring(0,2) != '05'"
                            @click="
                              modifyPopupOpen(
                                return_schedule_seq(td_item),
                                return_MedicalCode(td_item)
                              )
                            "
                          >
                            <i
                              class="vs-icon notranslate icon-scale feather icon-edit-2 null"
                              style="
                                order: 0;
                                margin-right: 0px;
                                margin-left: 0px;
                                color: #ffffff;
                              "
                            ></i>
                          </a>
                          <a
                            href="#"
                            class="n-content"
                            v-show="return_schedule_id(td_item).substring(0,2) != '05'"
                            @click="
                              calendarTdDelete(item.YM, item.Sun, index, 0, td_item)
                            "
                          >
                            <i
                              class="vs-icon notranslate icon-scale feather icon-x null"
                              style="
                                order: 0;
                                margin-right: 0px;
                                margin-left: 0px;
                                color: #ffffff;
                              "
                            ></i>
                          </a>
                        </vs-chip>
                      </template>
                    </div>
                  </td>
                  <td
                    class="border border-solid d-theme-border-grey-light"
                    :class="returnDay(item.Mon)"
                  >
                    <div class="day">
                      <div class="days_left"
                        :class="returnHoliDay(item.Mon)"
                      >
                        {{ dayReturn(item.Mon) }}
                      </div>
                      <div class="days_right">
                        <vs-button
                        class="n-content"
                          radius
                          color="dark"
                          type="line"
                          icon-pack="feather"
                          icon="icon-copy"
                          v-if="dayReturn(item.Mon) != ''"
                          @click="clipCopyConfirm(item.YM, item.Mon)"
                        ></vs-button>
                        <!-- <vs-button
                                                    radius
                                                    color="dark"
                                                    type="line"
                                                    icon-pack="feather"
                                                    icon="icon-plus"
                                                    v-if="dayReturn(item.Mon) != ''"
                                                    @click="calendarTdClick(item.YM, item.Mon, index, 1)"
                                                ></vs-button> -->
                        <vs-button
                          radius
                          class="n-content"
                          color="dark"
                          type="line"
                          icon-pack="feather"
                          icon="icon-user"
                          v-if="dayReturn(item.Mon) != ''"
                          @click="
                            [applyDateOnPopup(item, dayReturn(item.Mon)), popupOpen('02')]
                          "
                        />
                        <vs-button
                          radius
                          class="n-content"
                          color="dark"
                          type="line"
                          icon-pack="feather"
                          icon="icon-home"
                          v-if="dayReturn(item.Mon) != ''"
                          @click="
                            [applyDateOnPopup(item, dayReturn(item.Mon)), popupOpen('01')]
                          "
                        />
                        <vs-button
                        class="n-content"
                          radius
                          color="dark"
                          type="line"
                          icon-pack="feather"
                          icon="icon-truck"
                          v-if="dayReturn(item.Mon) != ''"
                          @click="
                            [applyDateOnPopup(item, dayReturn(item.Mon)), popupOpen('03')]
                          "
                        />
                      </div>
                    </div>
                    <div class="dayContents" v-bind:id="'calendar_td_' + item.Mon">
                      <template v-if="checkEtcScheduleDate('f/u', dayReturn(item.Mon))">
                        <vs-chip v-bind:color="etcScheduleColor('f/u')" class="w-full n-content">
                          F/U
                        </vs-chip>
                      </template>
                      <template
                        v-if="checkEtcScheduleDate('inspection', dayReturn(item.Mon))"
                      >
                        <vs-chip
                          v-bind:color="etcScheduleColor('inspection')"
                          class="w-full n-content"
                        >
                          검사
                        </vs-chip>
                      </template>
                      <template
                        v-if="checkEtcScheduleDate('indemStdt', dayReturn(item.Mon))"
                      >
                        <vs-chip
                          v-bind:color="etcScheduleColor('indemStdt')"
                          class="w-full n-content"
                        >
                          면책시작일
                        </vs-chip>
                      </template>
                      <template
                        v-if="checkEtcScheduleDate('indemEnddt', dayReturn(item.Mon))"
                      >
                        <vs-chip
                          v-bind:color="etcScheduleColor('indemEnddt')"
                          class="w-full n-content"
                        >
                          면책종료일
                        </vs-chip>
                      </template>
                      <template v-if="returnScheduleArr(item.Mon) != ''">
                        <!-- {{ returnScheduleArr(item.Mon) }} -->
                        <vs-chip
                          v-bind:color="returnValueClass(td_item)"
                          class="w-full v-content"
                          v-for="(td_item, td_index) in returnScheduleArr(item.Mon)"
                          :key="td_index"
                          v-show="return_schedule_id(td_item) != ''"
                        >
                          <input
                            type="checkbox"
                            v-show="return_schedule_id(td_item).substring(0,2) != '05'"
                            class="n-content"
                            v-model="copyChecked"
                            :value="return_schedule_seq(td_item)"
                          />
                          <span
                            :style="
                              returnDcYn(td_item) == 'Y'
                                ? 'text-decoration:line-through'
                                : ''
                            "
                            v-html="returnValueName(td_item)"
                          ></span>
                          <a
                            href="#"
                            class="n-content"
                            v-show="return_schedule_id(td_item).substring(0,2) != '05'"
                            @click="
                              modifyPopupOpen(
                                return_schedule_seq(td_item),
                                return_MedicalCode(td_item)
                              )
                            "
                          >
                            <i
                              class="vs-icon notranslate icon-scale feather icon-edit-2 null"
                              style="
                                order: 0;
                                margin-right: 0px;
                                margin-left: 0px;
                                color: #ffffff;
                              "
                            ></i>
                          </a>
                          <a
                            href="#"
                            class="n-content"
                            v-show="return_schedule_id(td_item).substring(0,2) != '05'"
                            @click="
                              calendarTdDelete(item.YM, item.Mon, index, 0, td_item)
                            "
                          >
                            <i
                              class="vs-icon notranslate icon-scale feather icon-x null"
                              style="
                                order: 0;
                                margin-right: 0px;
                                margin-left: 0px;
                                color: #ffffff;
                              "
                            ></i>
                          </a>
                        </vs-chip>
                      </template>
                    </div>
                  </td>
                  <td
                    class="border border-solid d-theme-border-grey-light"
                    :class="returnDay(item.Tue)"
                  >
                    <div class="day">
                      <div class="days_left"
                        :class="returnHoliDay(item.Tue)"
                      >
                        {{ dayReturn(item.Tue) }}
                      </div>
                      <div class="days_right">
                        <vs-button
                        class="n-content"
                          radius
                          color="dark"
                          type="line"
                          icon-pack="feather"
                          icon="icon-copy"
                          v-if="dayReturn(item.Tue) != ''"
                          @click="clipCopyConfirm(item.YM, item.Tue)"
                        ></vs-button>
                        <!-- <vs-button
                                                    radius
                                                    color="dark"
                                                    type="line"
                                                    icon-pack="feather"
                                                    icon="icon-plus"
                                                    v-if="dayReturn(item.Tue) != ''"
                                                    @click="calendarTdClick(item.YM, item.Tue, index, 2)"
                                                ></vs-button> -->
                        <vs-button
                        class="n-content"
                          radius
                          color="dark"
                          type="line"
                          icon-pack="feather"
                          icon="icon-user"
                          v-if="dayReturn(item.Tue) != ''"
                          @click="
                            [applyDateOnPopup(item, dayReturn(item.Tue)), popupOpen('02')]
                          "
                        />
                        <vs-button
                        class="n-content"
                          radius
                          color="dark"
                          type="line"
                          icon-pack="feather"
                          icon="icon-home"
                          v-if="dayReturn(item.Tue) != ''"
                          @click="
                            [applyDateOnPopup(item, dayReturn(item.Tue)), popupOpen('01')]
                          "
                        />
                        <vs-button
                        class="n-content"
                          radius
                          color="dark"
                          type="line"
                          icon-pack="feather"
                          icon="icon-truck"
                          v-if="dayReturn(item.Tue) != ''"
                          @click="
                            [applyDateOnPopup(item, dayReturn(item.Tue)), popupOpen('03')]
                          "
                        />
                      </div>
                    </div>
                    <div class="dayContents" v-bind:id="'calendar_td_' + item.Tue">
                      <template v-if="checkEtcScheduleDate('f/u', dayReturn(item.Tue))">
                        <vs-chip v-bind:color="etcScheduleColor('f/u')" class="w-full n-content">
                          F/U
                        </vs-chip>
                      </template>
                      <template
                        v-if="checkEtcScheduleDate('inspection', dayReturn(item.Tue))"
                      >
                        <vs-chip
                          v-bind:color="etcScheduleColor('inspection')"
                          class="w-full n-content"
                        >
                          검사
                        </vs-chip>
                      </template>
                      <template
                        v-if="checkEtcScheduleDate('indemStdt', dayReturn(item.Tue))"
                      >
                        <vs-chip
                          v-bind:color="etcScheduleColor('indemStdt')"
                          class="w-full n-content"
                        >
                          면책시작일
                        </vs-chip>
                      </template>
                      <template
                        v-if="checkEtcScheduleDate('indemEnddt', dayReturn(item.Tue))"
                      >
                        <vs-chip
                          v-bind:color="etcScheduleColor('indemEnddt')"
                          class="w-full n-content"
                        >
                          면책종료일
                        </vs-chip>
                      </template>
                      <template v-if="returnScheduleArr(item.Tue) != ''">
                        <vs-chip
                          v-bind:color="returnValueClass(td_item)"
                          class="w-full v-content"
                          v-for="(td_item, td_index) in returnScheduleArr(item.Tue)"
                          :key="td_index"
                          v-show="return_schedule_id(td_item) != ''"
                        >
                          <input
                            type="checkbox"
                            class="n-content"
                            v-show="return_schedule_id(td_item).substring(0,2) != '05'"
                            v-model="copyChecked"
                            :value="return_schedule_seq(td_item)"
                          />
                          <span
                            :style="
                              returnDcYn(td_item) == 'Y'
                                ? 'text-decoration:line-through'
                                : ''
                            "
                            v-html="returnValueName(td_item)"
                          ></span>
                          <a
                            href="#"
                            class="n-content"
                            v-show="return_schedule_id(td_item).substring(0,2) != '05'"
                            @click="
                              modifyPopupOpen(
                                return_schedule_seq(td_item),
                                return_MedicalCode(td_item)
                              )
                            "
                          >
                            <i
                              class="vs-icon notranslate icon-scale feather icon-edit-2 null"
                              style="
                                order: 0;
                                margin-right: 0px;
                                margin-left: 0px;
                                color: #ffffff;
                              "
                            ></i>
                          </a>
                          <a
                            href="#"
                            class="n-content"
                            v-show="return_schedule_id(td_item).substring(0,2) != '05'"
                            @click="
                              calendarTdDelete(item.YM, item.Tue, index, 0, td_item)
                            "
                          >
                            <i
                              class="vs-icon notranslate icon-scale feather icon-x null"
                              style="
                                order: 0;
                                margin-right: 0px;
                                margin-left: 0px;
                                color: #ffffff;
                              "
                            ></i>
                          </a>
                        </vs-chip>
                      </template>
                    </div>
                  </td>
                  <td
                    class="border border-solid d-theme-border-grey-light"
                    :class="returnDay(item.Wed)"
                  >
                    <div class="day">
                      <div class="days_left"
                        :class="returnHoliDay(item.Wed)"
                      >
                        {{ dayReturn(item.Wed) }}
                      </div>
                      <div class="days_right">
                        <vs-button
                        class="n-content"
                          radius
                          color="dark"
                          type="line"
                          icon-pack="feather"
                          icon="icon-copy"
                          v-if="dayReturn(item.Wed) != ''"
                          @click="clipCopyConfirm(item.YM, item.Wed)"
                        ></vs-button>
                        <!-- <vs-button
                                                    radius
                                                    color="dark"
                                                    type="line"
                                                    icon-pack="feather"
                                                    icon="icon-plus"
                                                    v-if="dayReturn(item.Wed) != ''"
                                                    @click="calendarTdClick(item.YM, item.Wed, index, 3)"
                                                ></vs-button> -->
                        <vs-button
                        class="n-content"
                          radius
                          color="dark"
                          type="line"
                          icon-pack="feather"
                          icon="icon-user"
                          v-if="dayReturn(item.Wed) != ''"
                          @click="
                            [applyDateOnPopup(item, dayReturn(item.Wed)), popupOpen('02')]
                          "
                        />
                        <vs-button
                        class="n-content"
                          radius
                          color="dark"
                          type="line"
                          icon-pack="feather"
                          icon="icon-home"
                          v-if="dayReturn(item.Wed) != ''"
                          @click="
                            [applyDateOnPopup(item, dayReturn(item.Wed)), popupOpen('01')]
                          "
                        />
                        <vs-button
                        class="n-content"
                          radius
                          color="dark"
                          type="line"
                          icon-pack="feather"
                          icon="icon-truck"
                          v-if="dayReturn(item.Wed) != ''"
                          @click="
                            [applyDateOnPopup(item, dayReturn(item.Wed)), popupOpen('03')]
                          "
                        />
                      </div>
                    </div>
                    <div class="dayContents" v-bind:id="'calendar_td_' + item.Wed">
                      <template v-if="checkEtcScheduleDate('f/u', dayReturn(item.Wed))">
                        <vs-chip v-bind:color="etcScheduleColor('f/u')" class="w-full n-content">
                          F/U
                        </vs-chip>
                      </template>
                      <template
                        v-if="checkEtcScheduleDate('inspection', dayReturn(item.Wed))"
                      >
                        <vs-chip
                          v-bind:color="etcScheduleColor('inspection')"
                          class="w-full n-content"
                        >
                          검사
                        </vs-chip>
                      </template>
                      <template
                        v-if="checkEtcScheduleDate('indemStdt', dayReturn(item.Wed))"
                      >
                        <vs-chip
                          v-bind:color="etcScheduleColor('indemStdt')"
                          class="w-full n-content"
                        >
                          면책시작일
                        </vs-chip>
                      </template>
                      <template
                        v-if="checkEtcScheduleDate('indemEnddt', dayReturn(item.Wed))"
                      >
                        <vs-chip
                          v-bind:color="etcScheduleColor('indemEnddt')"
                          class="w-full n-content"
                        >
                          면책종료일
                        </vs-chip>
                      </template>
                      <template v-if="returnScheduleArr(item.Wed) != ''">
                        <vs-chip
                          v-bind:color="returnValueClass(td_item)"
                          class="w-full v-content" 
                          v-for="(td_item, td_index) in returnScheduleArr(item.Wed)"
                          :key="td_index"
                          v-show="return_schedule_id(td_item) != ''"
                        >
                          <input
                            type="checkbox"
                            class="n-content"
                            v-show="return_schedule_id(td_item).substring(0,2) != '05'"
                            v-model="copyChecked"
                            :value="return_schedule_seq(td_item)"
                          />
                          <span
                            :style="
                              returnDcYn(td_item) == 'Y'
                                ? 'text-decoration:line-through'
                                : ''
                            "
                            v-html="returnValueName(td_item)"
                          ></span>
                          <a
                            href="#"
                            class="n-content"
                            v-show="return_schedule_id(td_item).substring(0,2) != '05'"
                            @click="
                              modifyPopupOpen(
                                return_schedule_seq(td_item),
                                return_MedicalCode(td_item)
                              )
                            "
                          >
                            <i
                              class="vs-icon notranslate icon-scale feather icon-edit-2 null"
                              style="
                                order: 0;
                                margin-right: 0px;
                                margin-left: 0px;
                                color: #ffffff;
                              "
                            ></i>
                          </a>
                          <a
                            href="#"
                            class="n-content"
                            v-show="return_schedule_id(td_item).substring(0,2) != '05'"
                            @click="
                              calendarTdDelete(item.YM, item.Wed, index, 0, td_item)
                            "
                          >
                            <i
                              class="vs-icon notranslate icon-scale feather icon-x null"
                              style="
                                order: 0;
                                margin-right: 0px;
                                margin-left: 0px;
                                color: #ffffff;
                              "
                            ></i>
                          </a>
                        </vs-chip>
                      </template>
                    </div>
                  </td>
                  <td
                    class="border border-solid d-theme-border-grey-light"
                    :class="returnDay(item.Thu)"
                  >
                    <div class="day">
                      <div class="days_left"
                        :class="returnHoliDay(item.Thu)"
                      >
                        {{ dayReturn(item.Thu) }}
                      </div>
                      <div class="days_right">
                        <vs-button
                        class="n-content"
                          radius
                          color="dark"
                          type="line"
                          icon-pack="feather"
                          icon="icon-copy"
                          v-if="dayReturn(item.Thu) != ''"
                          @click="clipCopyConfirm(item.YM, item.Thu)"
                        ></vs-button>
                        <!-- <vs-button
                                                    radius
                                                    color="dark"
                                                    type="line"
                                                    icon-pack="feather"
                                                    icon="icon-plus"
                                                    v-if="dayReturn(item.Thu) != ''"
                                                    @click="calendarTdClick(item.YM, item.Thu, index, 4)"
                                                ></vs-button> -->
                        <vs-button
                        class="n-content"
                          radius
                          color="dark"
                          type="line"
                          icon-pack="feather"
                          icon="icon-user"
                          v-if="dayReturn(item.Thu) != ''"
                          @click="
                            [applyDateOnPopup(item, dayReturn(item.Thu)), popupOpen('02')]
                          "
                        />
                        <vs-button
                        class="n-content"
                          radius
                          color="dark"
                          type="line"
                          icon-pack="feather"
                          icon="icon-home"
                          v-if="dayReturn(item.Thu) != ''"
                          @click="
                            [applyDateOnPopup(item, dayReturn(item.Thu)), popupOpen('01')]
                          "
                        />
                        <vs-button
                        class="n-content"
                          radius
                          color="dark"
                          type="line"
                          icon-pack="feather"
                          icon="icon-truck"
                          v-if="dayReturn(item.Thu) != ''"
                          @click="
                            [applyDateOnPopup(item, dayReturn(item.Thu)), popupOpen('03')]
                          "
                        />
                      </div>
                    </div>
                    <div class="dayContents" v-bind:id="'calendar_td_' + item.Thu">
                      <template v-if="checkEtcScheduleDate('f/u', dayReturn(item.Thu))">
                        <vs-chip v-bind:color="etcScheduleColor('f/u')" class="w-full n-content">
                          F/U
                        </vs-chip>
                      </template>
                      <template
                        v-if="checkEtcScheduleDate('inspection', dayReturn(item.Thu))"
                      >
                        <vs-chip
                          v-bind:color="etcScheduleColor('inspection')"
                          class="w-full n-content"
                        >
                          검사
                        </vs-chip>
                      </template>
                      <template
                        v-if="checkEtcScheduleDate('indemStdt', dayReturn(item.Thu))"
                      >
                        <vs-chip
                          v-bind:color="etcScheduleColor('indemStdt')"
                          class="w-full n-content"
                        >
                          면책시작일
                        </vs-chip>
                      </template>
                      <template
                        v-if="checkEtcScheduleDate('indemEnddt', dayReturn(item.Thu))"
                      >
                        <vs-chip
                          v-bind:color="etcScheduleColor('indemEnddt')"
                          class="w-full n-content"
                        >
                          면책종료일
                        </vs-chip>
                      </template>
                      <template v-if="returnScheduleArr(item.Thu) != ''">
                        <vs-chip
                          v-bind:color="returnValueClass(td_item)"
                          class="w-full v-content"
                          v-for="(td_item, td_index) in returnScheduleArr(item.Thu)"
                          :key="td_index"
                          v-show="return_schedule_id(td_item) != ''"
                        >
                          <input
                            type="checkbox"
                            class="n-content"
                            v-show="return_schedule_id(td_item).substring(0,2) != '05'"
                            v-model="copyChecked"
                            :value="return_schedule_seq(td_item)"
                          />
                          <span
                            :style="
                              returnDcYn(td_item) == 'Y'
                                ? 'text-decoration:line-through'
                                : ''
                            "
                            v-html="returnValueName(td_item)"
                          ></span>
                          <a
                            href="#"
                            class="n-content"
                            v-show="return_schedule_id(td_item).substring(0,2) != '05'"
                            @click="
                              modifyPopupOpen(
                                return_schedule_seq(td_item),
                                return_MedicalCode(td_item)
                              )
                            "
                          >
                            <i
                              class="vs-icon notranslate icon-scale feather icon-edit-2 null"
                              style="
                                order: 0;
                                margin-right: 0px;
                                margin-left: 0px;
                                color: #ffffff;
                              "
                            ></i>
                          </a>
                          <a
                            href="#"
                            class="n-content"
                            v-show="return_schedule_id(td_item).substring(0,2) != '05'"
                            @click="
                              calendarTdDelete(item.YM, item.Thu, index, 0, td_item)
                            "
                          >
                            <i
                              class="vs-icon notranslate icon-scale feather icon-x null"
                              style="
                                order: 0;
                                margin-right: 0px;
                                margin-left: 0px;
                                color: #ffffff;
                              "
                            ></i>
                          </a>
                        </vs-chip>
                      </template>
                    </div>
                  </td>
                  <td
                    class="border border-solid d-theme-border-grey-light"
                    :class="returnDay(item.Fri)"
                  >
                    <div class="day">
                      <div class="days_left"
                        :class="returnHoliDay(item.Fri)"
                      >
                        {{ dayReturn(item.Fri) }}
                      </div>
                      <div class="days_right">
                        <vs-button
                        class="n-content"
                          radius
                          color="dark"
                          type="line"
                          icon-pack="feather"
                          icon="icon-copy"
                          v-if="dayReturn(item.Fri) != ''"
                          @click="clipCopyConfirm(item.YM, item.Fri)"
                        ></vs-button>
                        <!-- <vs-button
                                                    radius
                                                    color="dark"
                                                    type="line"
                                                    icon-pack="feather"
                                                    icon="icon-plus"
                                                    v-if="dayReturn(item.Fri) != ''"
                                                    @click="calendarTdClick(item.YM, item.Fri, index, 5)"
                                                ></vs-button> -->
                        <vs-button
                        class="n-content"
                          radius
                          color="dark"
                          type="line"
                          icon-pack="feather"
                          icon="icon-user"
                          v-if="dayReturn(item.Fri) != ''"
                          @click="
                            [applyDateOnPopup(item, dayReturn(item.Fri)), popupOpen('02')]
                          "
                        />
                        <vs-button
                        class="n-content"
                          radius
                          color="dark"
                          type="line"
                          icon-pack="feather"
                          icon="icon-home"
                          v-if="dayReturn(item.Fri) != ''"
                          @click="
                            [applyDateOnPopup(item, dayReturn(item.Fri)), popupOpen('01')]
                          "
                        />
                        <vs-button
                        class="n-content"
                          radius
                          color="dark"
                          type="line"
                          icon-pack="feather"
                          icon="icon-truck"
                          v-if="dayReturn(item.Fri) != ''"
                          @click="
                            [applyDateOnPopup(item, dayReturn(item.Fri)), popupOpen('03')]
                          "
                        />
                      </div>
                    </div>
                    <div class="dayContents" v-bind:id="'calendar_td_' + item.Fri">
                      <template v-if="checkEtcScheduleDate('f/u', dayReturn(item.Fri))">
                        <vs-chip v-bind:color="etcScheduleColor('f/u')" class="w-full n-content">
                          F/U
                        </vs-chip>
                      </template>
                      <template
                        v-if="checkEtcScheduleDate('inspection', dayReturn(item.Fri))"
                      >
                        <vs-chip
                          v-bind:color="etcScheduleColor('inspection')"
                          class="w-full n-content"
                        >
                          검사
                        </vs-chip>
                      </template>
                      <template
                        v-if="checkEtcScheduleDate('indemStdt', dayReturn(item.Fri))"
                      >
                        <vs-chip
                          v-bind:color="etcScheduleColor('indemStdt')"
                          class="w-full n-content"
                        >
                          면책시작일
                        </vs-chip>
                      </template>
                      <template
                        v-if="checkEtcScheduleDate('indemEnddt', dayReturn(item.Fri))"
                      >
                        <vs-chip
                          v-bind:color="etcScheduleColor('indemEnddt')"
                          class="w-full n-content"
                        >
                          면책종료일
                        </vs-chip>
                      </template>
                      <template v-if="returnScheduleArr(item.Fri) != ''">
                        <vs-chip
                          v-bind:color="returnValueClass(td_item)"
                          class="w-full v-content"
                          v-for="(td_item, td_index) in returnScheduleArr(item.Fri)"
                          :key="td_index"
                          v-show="return_schedule_id(td_item) != ''"
                        >
                          <input
                            type="checkbox"
                            class="n-content"
                            v-show="return_schedule_id(td_item).substring(0,2) != '05'"
                            v-model="copyChecked"
                            :value="return_schedule_seq(td_item)"
                          />
                          <span
                            :style="
                              returnDcYn(td_item) == 'Y'
                                ? 'text-decoration:line-through'
                                : ''
                            "
                            v-html="returnValueName(td_item)"
                          ></span>
                          <a
                            href="#"
                            class="n-content"
                            v-show="return_schedule_id(td_item).substring(0,2) != '05'"
                            @click="
                              modifyPopupOpen(
                                return_schedule_seq(td_item),
                                return_MedicalCode(td_item)
                              )
                            "
                          >
                            <i
                              class="vs-icon notranslate icon-scale feather icon-edit-2 null"
                              style="
                                order: 0;
                                margin-right: 0px;
                                margin-left: 0px;
                                color: #ffffff;
                              "
                            ></i>
                          </a>
                          <a
                            href="#"
                            class="n-content"
                            v-show="return_schedule_id(td_item).substring(0,2) != '05'"
                            @click="
                              calendarTdDelete(item.YM, item.Fri, index, 0, td_item)
                            "
                          >
                            <i
                              class="vs-icon notranslate icon-scale feather icon-x null"
                              style="
                                order: 0;
                                margin-right: 0px;
                                margin-left: 0px;
                                color: #ffffff;
                              "
                            ></i>
                          </a>
                        </vs-chip>
                      </template>
                    </div>
                  </td>
                  <td
                    class="border border-solid d-theme-border-grey-light"
                    :class="returnDay(item.Sat)"
                  >
                    <!-- <div class="day sat">{{ dayReturn(item.Sat) }}</div> -->
                    <div class="day">
                      <div class="days_left sat">
                        {{ dayReturn(item.Sat) }}
                      </div>
                      <div class="days_right">
                        <vs-button
                        class="n-content"
                          radius
                          color="dark"
                          type="line"
                          icon-pack="feather"
                          icon="icon-copy"
                          v-if="dayReturn(item.Sat) != ''"
                          @click="clipCopyConfirm(item.YM, item.Sat)"
                        ></vs-button>
                        <!-- <vs-button
                                                    radius
                                                    color="dark"
                                                    type="line"
                                                    icon-pack="feather"
                                                    icon="icon-plus"
                                                    v-if="dayReturn(item.Sat) != ''"
                                                    @click="calendarTdClick(item.YM, item.Sat, index, 6)"
                                                ></vs-button> -->
                        <vs-button
                        class="n-content"
                          radius
                          color="dark"
                          type="line"
                          icon-pack="feather"
                          icon="icon-user"
                          v-if="dayReturn(item.Sat) != ''"
                          @click="
                            [applyDateOnPopup(item, dayReturn(item.Sat)), popupOpen('02')]
                          "
                        />
                        <vs-button
                        class="n-content"
                          radius
                          color="dark"
                          type="line"
                          icon-pack="feather"
                          icon="icon-home"
                          v-if="dayReturn(item.Sat) != ''"
                          @click="
                            [applyDateOnPopup(item, dayReturn(item.Sat)), popupOpen('01')]
                          "
                        />
                        <vs-button
                        class="n-content"
                          radius
                          color="dark"
                          type="line"
                          icon-pack="feather"
                          icon="icon-truck"
                          v-if="dayReturn(item.Sat) != ''"
                          @click="
                            [applyDateOnPopup(item, dayReturn(item.Sat)), popupOpen('03')]
                          "
                        />
                      </div>
                    </div>
                    <div class="dayContents" v-bind:id="'calendar_td_' + item.Sat">
                      <template v-if="checkEtcScheduleDate('f/u', dayReturn(item.Sat))">
                        <vs-chip v-bind:color="etcScheduleColor('f/u')" class="w-full n-content">
                          F/U
                        </vs-chip>
                      </template>
                      <template
                        v-if="checkEtcScheduleDate('inspection', dayReturn(item.Sat))"
                      >
                        <vs-chip
                          v-bind:color="etcScheduleColor('inspection')"
                          class="w-full n-content"
                        >
                          검사
                        </vs-chip>
                      </template>
                      <template
                        v-if="checkEtcScheduleDate('indemStdt', dayReturn(item.Sat))"
                      >
                        <vs-chip
                          v-bind:color="etcScheduleColor('indemStdt')"
                          class="w-full n-content"
                        >
                          면책시작일
                        </vs-chip>
                      </template>
                      <template
                        v-if="checkEtcScheduleDate('indemEnddt', dayReturn(item.Sat))"
                      >
                        <vs-chip
                          v-bind:color="etcScheduleColor('indemEnddt')"
                          class="w-full n-content"
                        >
                          면책종료일
                        </vs-chip>
                      </template>
                      <template v-if="returnScheduleArr(item.Sat) != ''">
                        <vs-chip
                          v-bind:color="returnValueClass(td_item)"
                          class="w-full v-content"
                          v-for="(td_item, td_index) in returnScheduleArr(item.Sat)"
                          :key="td_index"
                          v-show="return_schedule_id(td_item) != ''"
                        >
                          <input
                            type="checkbox"
                            class="n-content"
                            v-show="return_schedule_id(td_item).substring(0,2) != '05'"
                            v-model="copyChecked"
                            :value="return_schedule_seq(td_item)"
                          />
                          <span
                            :style="
                              returnDcYn(td_item) == 'Y'
                                ? 'text-decoration:line-through'
                                : ''
                            "
                            v-html="returnValueName(td_item)"
                          ></span>
                          <a
                            href="#"
                            v-show="return_schedule_id(td_item).substring(0,2) != '05'"
                            class="n-content"
                            @click="
                              modifyPopupOpen(
                                return_schedule_seq(td_item),
                                return_MedicalCode(td_item)
                              )
                            "
                          >
                            <i
                              class="vs-icon notranslate icon-scale feather icon-edit-2 null"
                              style="
                                order: 0;
                                margin-right: 0px;
                                margin-left: 0px;
                                color: #ffffff;
                              "
                            ></i>
                          </a>
                          <a
                            href="#"
                            class="n-content"
                            v-show="return_schedule_id(td_item).substring(0,2) != '05'"
                            @click="
                              calendarTdDelete(item.YM, item.Sat, index, 0, td_item)
                            "
                          >
                            <i
                              class="vs-icon notranslate icon-scale feather icon-x null"
                              style="
                                order: 0;
                                margin-right: 0px;
                                margin-left: 0px;
                                color: #ffffff;
                              "
                            ></i>
                          </a>
                        </vs-chip>
                      </template>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        </vx-card>
      </div>
    </div>
    <!-- 스케줄 등록 및 수정 -->
    <vs-popup
      :title="schedulePopupTitle"
      id="schedulePopup"
      :active.sync="schedulePopupActive"
    >
      <form @submit.prevent>
        <div class="vx-row mb-3">
          <div class="vx-col w-full lg:w-1/1">
            <v-select
              :maxHeight="'50px'"
              @input="selectMedicalDetail"
              v-model="selectedMedicalCode"
              :options="tab_options"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
            >
            </v-select>
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col w-full lg:w-1/2">
            <label for="" class="vs-select--label">날짜</label>
            <datepicker
              name="uniquename"
              v-model="scheduleSelectDate"
              placeholder="날짜선택"
              :format="customFormatter"
            ></datepicker>
          </div>
          <div class="vx-col w-full lg:w-1/2">
            <label for="" class="vs-select--label">시간(hhmm)-ex.0930</label>
            <input
              type="text"
              class="w-full vs-inputx vs-input--input normal hasValue"
              id="scheduleSelectTime"
              name="scheduleSelectTime"
              label="시간을 입력해주세요."
              placeholder="시간을 입력해주세요."
              maxlength="4"
              v-model="scheduleSelectTime"
            />
          </div>
        </div>
        <div class="vx-row mb-3" v-if="this.medicalCode == '02'">
          <div class="vx-col w-full lg:w-1/2">
            <vs-select
              class="w-auto"
              v-model="selectGubun"
              autocomplete
              label="등록 구분"
              placeholder="등록 구분"
              @change="[gubunChange]"
            >
              <vs-select-item :value="''" :text="'-선택-'" />
              <vs-select-item
                v-for="(item, index) in gubun_list"
                :key="index"
                :value="item.VALUE"
                :text="item.TEXT"
              />
            </vs-select>
          </div>
        </div>
        <vs-divider color="danger">DC</vs-divider>
        <div class="vx-row mb-3">
          <div class="vx-col w-full lg:w-1/2 justify-between">
              <span>
                  <vs-checkbox v-model="dc" style="width: 30%;">
                      DC
                  </vs-checkbox>
              </span>
          </div>
          <div class="vx-col w-full lg:w-1/2 justify-between">
              <span>
                  <vs-checkbox v-model="awaitTimeChk" @change="setAwaitTime" style="width: 30%;">
                      대기
                  </vs-checkbox>
              </span>
          </div>
          <div class="vx-col w-full lg:w-1/1 justify-between">
              <template v-if="dc == true">
                  <vs-input v-model="dc_memo" placeholder="취소사유" class="mt-1 w-full" />
              </template>
              <template v-if="awaitTimeChk == true">
                  <vs-input v-model="awaitTime" placeholder="시간" class="mt-1 w-full" v-show="this.userUid == '04059'"/>
              </template>
          </div>
        </div>
        <template v-if="this.medicalCode != '02'">
          <vs-divider color="danger">치료자</vs-divider>
          <div class="vx-row mb-3">
            <div
              class="vx-col lg:w-1/1 justify-between"
              v-for="(item, index) in viewManagerList"
              :key="index"
            >
              <input
                type="radio"
                class="mr-2"
                :id="item.MEDICAL_MANAGER_NM"
                v-model="medicalManagers"
                :value="item.MEDICAL_MANAGER_CD"
              />
              <label :for="item.MEDICAL_MANAGER_NM">{{ item.MEDICAL_MANAGER_NM }}</label>
            </div>
          </div>
        </template>
        <template v-if="viewDetailList.length > 0">
          <vs-divider color="danger">스케줄</vs-divider>
          <div class="vx-row mb-3">
            <div
              class="vx-col lg:w-1/1 justify-between"
              v-for="(item, index) in viewDetailList"
              :key="index"
            >
              <input
                type="checkbox"
                class="mr-2"
                :id="item.MEDICAL_DETAIL_NM"
                v-model="medicalDetails"
                :value="item.MEDICAL_DETAIL_CD"
              />
              <label :for="item.MEDICAL_DETAIL_NM">{{ item.MEDICAL_DETAIL_NM }}</label>
            </div>
          </div>
        </template>
        <div
          v-if="
            selectGubun == '1' ||
            selectGubun == '2' ||
            selectGubun == '3' ||
            selectGubun == '4' ||
            selectGubun == '5' ||
            selectGubun == '6' ||
            selectGubun == '98'
          "
        >
          <vs-divider color="danger">환자</vs-divider>
          <div class="vx-row mb-3">
            <div class="vx-col w-full lg:w-1/1">
              <vs-input class="w-full" v-model="patientUserInfo" readOnly="readOnly" />
            </div>
          </div>
        </div>

        <vs-divider color="danger">메모</vs-divider>
        <div class="vx-row mb-3">
          <div class="vx-col w-full lg:w-1/1">
            <textarea
              v-model="scheduleMemo"
              id="scheduleMemo"
              class="vs-component vs-con-textarea vs-textarea-primary"
              style="border: 1px solid rgba(0, 0, 0, 0.08); padding: 20px; resize: none"
              value=""
            ></textarea>
          </div>
        </div>
        <div class="mb-3" v-if="this.medicalCode == '02'">
          <vs-divider color="danger">비고</vs-divider>
          <vs-input
            class="w-full"
            name="memo_etc"
            v-model="memo_etc"
            label=""
            placeholder="비고"
          />
        </div>
        <div class="vx-row" style="margin-top: 300px">
          <div class="vx-col w-full text-right">
            <vs-button class="mr-3 mb-2" @click="scheduleSave">저장</vs-button>
            <vs-button color="warning" type="border" class="mb-2" @click="popupClose"
              >닫기</vs-button
            >
          </div>
        </div>
      </form>
    </vs-popup>
    <vs-popup title="알림톡 발송" :active.sync="kakaoPopup">
      <form @submit.prevent>
        <div class="vx-row mb-3">
          <div class="vx-col w-full lg:w-1/2 ">
            <label for="" class="vs-select--label">날짜 선택</label>
            <date-picker name="kakao_date" v-model="kakao_date" :locale="'ko'" valueType="format"
              class="vs-inputx normal w-full"></date-picker>
          </div>
          <div class="vx-col w-full lg:w-1/2">
            <vs-select autocomplete class="w-auto" name="messageSelect" v-model="messageSelect" label="메시지 수동 발송 선택"
              placeholder="선택해주세요.">
              <vs-select-item value="" text="초기값" />
              <vs-select-item value="1" text="스케줄(기존)" />
              <vs-select-item value="K" text="직통번호 안내" />
              <vs-select-item value="M" text="퇴원약 주사 안내" />
              <vs-select-item value="A" text="병실 안내" />
              <vs-select-item value="B" text="비용 안내" />
              <vs-select-item value="C" text="입원예정서 안내" />
              <vs-select-item value="D" text="위치 안내" />
              <vs-select-item value="E" text="방문상담 전날" />
              <vs-select-item value="F" text="방문상담 당일" />
              <vs-select-item value="G" text="상담 후" />
              <vs-select-item value="H" text="상담 후(부인과)" />
              <vs-select-item value="I" text="입원확정시" />
              <vs-select-item value="J" text="입원 전날" />
            </vs-select>
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col w-full lg:w-1/2 ">
            <label for="" class="vs-input--label">메시지 발송 대상자</label>
            <div class="vx-row mb-3 ml-2">
              <vs-checkbox type="checkbox" vs-value="1" v-model="messageResponder_1">
                환자본인</vs-checkbox>
              <vs-checkbox type="checkbox" vs-value="2" v-model="messageResponder_2">
                보호자</vs-checkbox>
              <vs-checkbox type="checkbox" vs-value="3" v-model="messageResponder_3">
                보호자2</vs-checkbox>
            </div>
          </div>
        </div>

        <div class="vx-row" style="margin-top:300px;">
          <div class="vx-col w-full text-right">
            <vs-button class="mr-3 mb-2" @click="kakaoSend">즉시발송</vs-button>
            <vs-button color="warning" type="border" class="mb-2" @click="kakaoClose">닫기</vs-button>
          </div>
        </div>
      </form>
    </vs-popup>


    <vs-popup id="alramTalk" title="알림톡 발송" :active.sync="alramTalk">
      <form @submit.prevent>
        <div class="vx-row mb-3">
          <div class="vx-col w-full lg:w-1/2 ">
            <label for="" class="vs-select--label">날짜 선택</label>
            <date-picker name="kakao_date" v-model="kakao_date" :locale="'ko'" valueType="format"
              class="vs-inputx normal w-full"></date-picker>
          </div>

        </div>

        <div class="vx-row" style="margin-top:300px;">
          <div class="vx-col w-full text-right">
            <vs-button class="mr-3 mb-2" @click="kakaoSend">즉시발송</vs-button>
            <vs-button color="warning" type="border" class="mb-2" @click="kakaoClose">닫기</vs-button>
          </div>
        </div>
      </form>
    </vs-popup>

    <!-- 다중 복사 팝업 -->
    <vs-popup title="다중 복사" :active.sync="multiCopyPopup" class="multi-copy-popup">
        <div class="multi-copy-container">
            <div class="multi-copy-schedule-section">
                <h5>복사할 스케줄 선택</h5>
                <div v-for="(schedule, index) in getSelectedSchedulesForMultiCopy()" :key="index" class="schedule-item mb-2 p-2 border rounded">
                    <input type="checkbox" v-model="multiCopyChecked" :value="schedule.seq" class="mr-2" />
                    <span>{{ formatScheduleTime(schedule.time) }}</span>
                    <span class="ml-2">[{{ schedule.medical ? schedule.medical.substring(0, 1) : '' }}]</span>
                    <span class="ml-2">{{ schedule.room }} {{ schedule.patient }}</span>
                </div>
            </div>

            <div class="multi-copy-dates-section">
                <h5>복사할 날짜/시간 설정</h5>
                <div class="target-dates-container">
                    <div v-for="(target, index) in targetDates" :key="index" class="target-date-item mb-2 p-2 border rounded">
                        <div class="flex items-center justify-between">
                            <div class="flex items-center">
                                <datepicker
                                    v-model="target.date"
                                    :format="customFormatter"
                                    placeholder="날짜 선택"
                                    class="mr-2"
                                />
                                <input
                                    type="text"
                                    v-model="target.time"
                                    placeholder="시간(HHMM)"
                                    maxlength="4"
                                    class="vs-inputx vs-input--input time-input"
                                />
                            </div>
                            <vs-button type="border" color="danger" size="small" @click="removeTargetDate(index)">삭제</vs-button>
                        </div>
                    </div>
                    <vs-button type="border" color="primary" size="small" @click="addTargetDate">날짜 추가</vs-button>
                </div>
            </div>

            <div class="multi-copy-buttons">
                <vs-button class="mr-2" @click="executeMultiCopy">다중 복사</vs-button>
                <vs-button color="warning" type="border" @click="closeMultiCopyModal">취소</vs-button>
            </div>
        </div>
    </vs-popup>
  </div>
</template>

<script>
import axiosClass from "@/../util/axiosClass";
import dateClass from "@/../util/dateClass";
import store from "@/store/store";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import moment from "moment";
import Datepicker from "vuejs-datepicker";
import vSelect from "vue-select";
import { EventBus } from "../../../util/vue-event-bus";
import $ from "jquery";
import Vue from "vue";
import Xlsx from 'xlsx';
import printJS from 'print-js'

export default {
  name: 'ScheduleCalendar',
  components: {
    DatePicker,
    Datepicker,
    "v-select": vSelect,
  },
  data() {
    return {
      calendar_temp: [],
      calendar_date: [],
      now_date: dateClass.dateYYYYMM(),
      prev_date: "",
      next_date: "",
      today: null,
      calendar_data: [],

      lists: [],
      plan: "",

      addrOptions: [],
      openPopup1: false,
      userUid: "",
      lists: [],
      page: 1,
      pageLimit: 15,
      totalCount: 0,
      pageCount: 0,
      listIndex: -1,
      patientUid: "",
      patientName: "",
      search: "",
      chartNo: "",
      patientUsername: "",
      sickNess: "",
      gisu: "",
      jumin: "",
      patientBirthday: "",
      patientGender: "",
      age: "",
      plan: "",
      newRe: "신입",
      cdStatus: "",
      inInitDate: "",
      inDate: "",
      inTime: "",
      outTime: "",
      outDate: "",
      completeYn: "N",
      mealTime: "",
      mealName: "",
      mealMemo: "",
      breakfast_mealName: "",
      lunch_mealName: "",
      dinner_mealName: "",
      medical_member_name: "",
      westMedicalNm: "",
      patientPhone: "",
      address: "",
      protectorPhone: "",
      protectorPhone2: "",
      protectorYN: "N",
      medicalName: "",
      medicalNameText: "",
      insuranceChk: false,
      insuranceName: "",
      insuranceNameText: "",
      inLimit: "",
      inLimitText: "",
      inGuarantee: "",
      balance: "",
      confirmDate: dateClass.getDate("YYYY-MM-DD"),
      outpatDayLimit: "",
      outpatDayLimitText: "",
      outPatCount: "",
      indemStdt: "",
      indemEnddt: "",
      joinDate: "",
      memo: "",
      corona: "",
      medicalMemberList: [],
      medicalCenterList: [],
      insuranceCenterList: [],
      inLimitList: [],
      statusList: [],
      medicalRoomNumberListEtc: [],
      tab_menu: [],
      medical_room_seq: "",
      tb_menu: [
        "관리병동",
        "차트번호",
        "이름",
        "전화번호",
        "나이",
        "성별",
        "상태",
        "주치의",
        "협진의",
        "관리",
      ],
      searchStaus: "",
      kakaoPopup: false,
      kakao_date: dateClass.getDate("YYYY-MM-DD"),
      juminTF: false,
      medicalRoomList: [],
      medicalRoomNm: "",
      medicalRoomNumberList2: [],
      medicalRoomNumberNm: "",
      medicalRoomNumberNm_detail: "",
      medicalRoomNumberCntList: [],
      medicalRoomNumberCnt: "",
      sickNessList: [],
      sickNessText: "",
      addressList: [],
      addressText: "",
      protectorList: [],
      protector: "",
      protector2: "",
      mealTimeList: [],
      mealNameList: [],
      mealMemoList: [],
      mealMemoText: "",
      coronaList: [],
      bodyPartList: [],
      anamnesisList: [],
      bodyPart: "",
      diagnosisDate: "",
      operationDate: "",
      metastasisYn: "",
      metastasisPart: "",
      anticancerDate: "",
      radiotherapyDate: "",
      antiagentYn: "Y",
      antiagent: "",
      medication: "",
      anamnesisYn: "N",
      anamnesis: [],
      anamnesisEtc: "",
      csPopup: false,
      csPathList: [],
      csCateList: [],
      csMemberList: [],
      mainCsMemberList: [],
      csFavorList: [],
      csIssueList: [],
      csDatas: [],
      nutritionMemo: "",
      popTabIdx: 1,
      tab_sum: 0,
      expire: false,
      width: window.innerWidth,
      cdStatusChange_YN: "",
      kakao_sender: 1,
      csRel: ["환자본인", "보호자1", "보호자2"],
      etcMemo: "",
      roomMemo: "",
      csMemo: "",
      cs2Memo: "",
      roomlist: [],
      tabArray_01: [],
      mainCs: "",
      mainCsCaller: "1",
      mainCsCallerPhone: "",
      initPath: "",
      issueText: "",
      userLevel: "",

      alramTalk: false,
      alramTalkData1: false,
      alramTalkData2: false,
      alramTalkData3: false,
      alramTalkData4: false,
      alramTalkData5: false,
      alramTalkData6: false,
      messageSelect: "",
      messageResponder_1: false,
      messageResponder_2: false,
      messageResponder_3: false,
      classInfo: "1",

      // 기존코드
      medical_code_list: [],
      time_list: [],
      calendarWritePopup: false,

      patient_member_uid: "",
      select_date: "",
      medical_cd: "",
      select_time: "",
      row_index: -1,
      cell_index: -1,
      schedule_seq: -1,
      patientUsername: "",
      patientAge: "",
      patientGender: "",
      medicalRoomNm: "",
      medicalRoomNumberNm: "",
      medicalName: "",
      sickNess: "",
      plan: "",
      memo: "",
      chart_no: "",
      status_name: "",
      patient_phone: "",
      in_init_date: "",
      in_date: "",
      out_date: "",
      complate_yn: "",
      meal_name: "",
      medical_nm: "",
      west_medical_nm: "",
      protector_phone: "",
      detailList: [],
      copyChecked: [],
      copy_select_date: "",
      copy_select_time: "",
      now_day: "",
      
      // 다중 복사 관련 데이터
      multiCopyPopup: false,
      multiCopyChecked: [],
      targetDates: [],
      width: window.innerWidth,

      // 230314 TH 추가
      nextCD: "",
      options: [],
      disabledDate: true,
      selectedMedicalCode: {},
      medicalManagers: "",
      dc_memo: "",
      viewManagerList: [],
      viewDetailList: [],
      managerList: [],
      medicalDetails: [],
      select_user: "",
      schedulePopupActive: false,
      tab_options: [],
      dc: false,
      cure_data: [],
      date_list: [],
      cure_count: [],
      tab_all_tf: false,
      medicalCode: "",
      scheduleSelectDate: "",
      scheduleSelectTime: "",
      scheduleMemo: "",
      patientId: "",
      patientList: [],
      schedulePopupTitle: "",
      patientUserInfo: "",
      searchPatientList: [],
      followUpDate: "",
      inspectionDate: "",
      followUpColor: "rgb(255,102,102)",
      inspectionColor: "rgb(204,102,153)",
      indemStdtColor: "rgb(051,102,153)",
      indemEnddtColor: "rgb(051,153,051)",
      consultDoctor: "",
      gubun_list: [
        { VALUE: "1", TEXT: "초진" },
        { VALUE: "2", TEXT: "재진" },
        { VALUE: "3", TEXT: "신입진료" },
        { VALUE: "4", TEXT: "재입진료" },
        { VALUE: "5", TEXT: "입원중진료" },
        { VALUE: "6", TEXT: "퇴원진료" },
        //{ VALUE: "97", TEXT: "휴진" },
        { VALUE: "98", TEXT: "외래" },
        //{ VALUE: "99", TEXT: "기타" },
      ],
      selectGubunIndex: "",
      selectGubun: "",
      schdule_endYN: "",
      schedule_end: "",
      schedule_week: [],
      schedule_gubun_type: "",
      schedule_gubun_number: "",
      schedule_gubun_days: "",
      memo_etc: "",
      authCheck: "",
      awaitTime : '',
      awaitTimeChk : false,
      userUid : '',
      calendar_data2: [],
      mergedCalendarData: [],
      holidayArr: [],
      prevScheduleData: {},
      oxygenPoint : 0,
      nowDate: dateClass.dateYYYYMM(),
      inLongTerm: "",
    };
  },

  computed: {
    displayDate() {
      return this.nowDate.substring(0, 4) + "년 " + this.nowDate.substring(4, 6) + "월";
    },
    isMultiCopyEnabled() {
      return this.copyChecked && this.copyChecked.length > 0;
    },
  },
  watch: {
    nowDate: {
      handler(newVal) {
        this.now_date = newVal;
        //this.getScheduleList();
      },
      immediate: true
    }
  },
  created() {

  },
  methods: {
    handleResize(event) {
      this.width = window.innerWidth;
    },
    async init(date) {
      if (date == "") {
        this.now_date = dateClass.dateYYYYMM();
      } else {
        this.now_date = date;
      }
      this.userUid = store.getters.getUID;
      this.prev_date = dateClass.prevYYYYMM(this.now_date);
      this.next_date = dateClass.nextYYYYMM(this.now_date);
      const jsonData = {
        year_month: this.now_date,
        uid: this.loginUid,
      };

      //console.log(this.$route.params.uid);
      if (this.$route.params.uid != null && this.$route.params.uid != undefined) {
        this.patient_member_uid = this.$route.params.uid;
      }

      //console.info("init processing...");
      this.now_day = dateClass.dateYYYYMMDD().substring(6, 8);
      // this.now_day = '20220307';
      // console.log('now_day: ' + dateClass.dateYYYYMMDD().substring(6, 8));

      this.$vs.loading({
        type: "default",
        container: "#scheduleRootDiv",
        background: "rgba(0,0,0,0.1)",
        color: "primary",
        scale: 1.5,
      });

      const { data } = await axiosClass.get(
        "/api/patientCalendar/list/" + this.patient_member_uid,
        jsonData,
        true
      );

      setTimeout(() => {
        this.$vs.loading.close("#scheduleRootDiv > .con-vs-loading");
      }, 100);

      this.lists = data.patientData;
      this.plan = "";

      this.calendar_data = data.calendar;
      this.calendar_data2 = data.calendar2;
      this.mergedCalendarData = this.mergeCalendarData(this.calendar_data, this.calendar_data2);

      // patientData null 체크 추가 (2026-02-05)
      if (data.patientData) {
        this.patientUsername = data.patientData.PATIENT_USERNAME;
        this.patientAge = data.patientData.PATIENT_AGE;
        this.patientGender = data.patientData.PATIENT_GENDER_CONVERT;
        this.medicalRoomNm = data.patientData.MEDICAL_ROOM_NM;
        this.medicalRoomNumberNm = data.patientData.MEDICAL_ROOM_NUMBER_NM;
        this.medicalName = data.patientData.MEDICAL_NAME;
        this.sickNess = data.patientData.SICKNESS;
        this.plan = data.patientData.PLAN;
        this.memo = data.patientData.MEMO;

        // 추가사항 2021.02.23
        this.chart_no = data.patientData.CHART_NO;
        this.status_name = data.patientData.STATUS_NAME;
        this.patient_phone = data.patientData.PATIENT_PHONE;
        this.in_init_date = data.patientData.IN_INIT_DATE;
        this.in_date = data.patientData.IN_DATE;
        this.out_date = data.patientData.OUT_DATE;
        this.complate_yn = data.patientData.COMPLATE_YN;
        this.meal_name = data.patientData.MEAL_NAME;
        this.medical_nm = data.patientData.MEDICAL_NM;
        this.west_medical_nm = data.patientData.WEST_MEDICAL_NM;
        this.protector_phone = data.patientData.PROTECTOR_PHONE;
        // 230314 TH추가
        this.nextCD = data.patientData.MEDICAL_ROOM_NUMBER_CNT;
      } else {
        // 환자 데이터 없음 - 기본값 설정
        this.patientUsername = '';
        this.patientAge = '';
        this.patientGender = '';
        this.medicalRoomNm = '';
        this.medicalRoomNumberNm = '';
        this.medicalName = '';
        this.sickNess = '';
        this.memo = '';
        this.chart_no = '';
        this.status_name = '';
        this.patient_phone = '';
        this.in_init_date = '';
        this.in_date = '';
        this.out_date = '';
        this.complate_yn = '';
        this.meal_name = '';
        this.medical_nm = '';
        this.west_medical_nm = '';
        this.protector_phone = '';
        this.nextCD = 0;
      }

      this.detailList = data.detailList;
      // console.log("this.detailList:::", this.detailList);
      // console.log(this.calendar_data);

      // 추가코드 - 치료실 스케줄과 동일한 필터링/정렬 로직 적용 (2026-02-05)
      this.tab_menu = [];
      for (let i = 0; i < data.tab_menu.length; i++) {
        if (data.tab_menu[i].TAB_CODE != false) {
          this.tab_menu.push(data.tab_menu[i]);
        }
      }
      this.tab_menu.sort((a, b) => (a.ORDER_INT || 0) - (b.ORDER_INT || 0));

      // tab_options 초기화 - 치료실 스케줄과 동일하게 설정 (2026-02-05)
      this.tab_options = [];
      for (let i = 0; i < this.tab_menu.length; i++) {
        this.tab_options.push({
          id: this.tab_menu[i].MEDICAL_CD,
          label: this.tab_menu[i].MEDICAL_NM,
        });
      }

      this.medicalMemberList = data.medicalMemberList;
      this.medicalCenterList = data.medicalCenterList;
      this.insuranceCenterList = data.insuranceCenterList;
      this.sickNessList = data.sickNessList;
      this.addressList = data.addressList;
      this.protectorList = data.protectorList;
      this.mealTimeList = data.mealTimeList;
      this.mealNameList = data.mealNameList;
      this.mealMemoList = data.mealMemoList;
      this.coronaList = data.coronaList;
      //
      this.holidayArr = data.holidayArr;
      if (this.addrOptions.length == 0) {
        let addrOptions_Obj = {};
        addrOptions_Obj.group = [];
        for (let i = 0; i < data.addressList.length; i++) {
          const obj = data.addressList[i];
          const _do = obj.DO;
          const _bf_do = i > 0 ? data.addressList[i - 1].DO : "";
          const _si = obj.SI;
          const groupObj = { text: _si, value: _si };
          if (_do != _bf_do) {
            if (i > 0) {
              this.addrOptions.push(addrOptions_Obj);
            }
            addrOptions_Obj = {};
            addrOptions_Obj.group = [];
            addrOptions_Obj.title = _do;
          } else {
            if (data.addressList.length == i + 1) {
              this.addrOptions.push(addrOptions_Obj);
            }
          }
          addrOptions_Obj.group.push(groupObj);
        }
      }
      // console.log(data.calendar);

      this.statusList = data.statusList;
      this.medicalRoomNumberListEtc = data.medicalRoomNumberListEtc;
      this.medicalRoomList = data.medicalRoomList;
      this.bodyPartList = data.bodyPartList;
      this.anamnesisList = data.anamnesisList;
      this.csPathList = data.csPathList;
      this.csCateList = data.csCateList;
      this.csMemberList = data.csMemberList;
      this.mainCsMemberList = data.mainCsMemberList;
      this.csFavorList = data.csFavorList;

      this.csIssueList = data.csIssueList;

      // patientData null 체크 추가 (2026-02-05)
      if (data.patientData) {
        this.followUpDate =
          data.patientData.FOLLOWUP_DATE == "" ? "" : data.patientData.FOLLOWUP_DATE;
        this.inspectionDate =
          data.patientData.INSPECTION_DATE == "" ? "" : data.patientData.INSPECTION_DATE;
        this.indemStdt = data.patientData.INDEMSTDT == "" ? "" : data.patientData.INDEMSTDT;
        this.indemEnddt =
          data.patientData.INDEMENDDT == "" ? "" : data.patientData.INDEMENDDT;
        this.consultDoctor =
          data.patientData.CONSULT_DOCTOR == "" ? "" : data.patientData.CONSULT_DOCTOR;
        this.oxygenPoint = data.patientData.OXYGEN_POINT;
        this.inLongTerm = data.patientData.IN_LONG_TERM;
      } else {
        this.followUpDate = "";
        this.inspectionDate = "";
        this.indemStdt = "";
        this.indemEnddt = "";
        this.consultDoctor = "";
        this.oxygenPoint = 0;
        this.inLongTerm = "";
      }
      this.selectedMedicalCode = {};
      this.scheduleSelectDate = "";
      this.scheduleSelectTime = "";
      this.tab_medical_cd = "";
      this.schedule_seq = "";
      this.memo = "";
      this.dc = "";
      this.dc_memo = "";
      this.medicalDetails = [];
      this.medicalManagers = [];
      this.viewDetailList = [];
      this.viewManagerList = [];
      this.searchPatientList = [];
      this.medicalCode = "";

      if (this.status_name == null) {
        this.status_name = "";
      }

      if (this.patient_phone == null) {
        this.patient_phone = "";
      }

      if (this.patient_member_uid == null || this.patient_member_uid == undefined) {
        this.patientUserInfo = "환자를 검색 해주세요";
      } else {
        this.patientUserInfo =
          this.chart_no +
          "/" +
          this.status_name +
          ":" +
          this.patientUsername +
          "(" +
          this.patient_phone.substring(
            this.patient_phone.lastIndexOf("-") + 1,
            this.patient_phone.length
          ) +
          ")";
      }
    },
    async calendarPopup() {
      this.calendarWritePopup = true;
    },
    calendar(date) {
      this.now_date = dateClass.nowDate(date);
      this.prev_date = dateClass.prevYYYYMM(
        this.now_date.substring(0, 8).replace(/-/gi, "")
      );
      this.next_date = dateClass.nextYYYYMM(
        this.now_date.substring(0, 8).replace(/-/gi, "")
      );
      this.today = new Date(this.now_date);
      if (this.today.getMonth() + 1 < 10) {
        this.setCalendarData(this.today.getFullYear(), "0" + (this.today.getMonth() + 1));
      } else {
        this.setCalendarData(this.today.getFullYear(), "" + (this.today.getMonth() + 1));
      }
    },
    async calendarTdClick(ym, date, row_index, cell_index) {
      // console.log(ym, date);
      this.calendarWritePopup = true;

      this.select_date = "";
      this.row_index = -1;
      this.cell_index = -1;
      this.schedule_seq = -1;

      this.medical_cd = "";
      this.select_time = "";

      const temp = date.split("///");
      const day = temp[0];
      this.select_date = ym + this.setFixDayCount(day);
      this.row_index = row_index;
      this.cell_index = cell_index;

      const { data } = await axiosClass.get(
        "/api/patientCalendar/calendarSelect/" +
          this.patient_member_uid +
          "/" +
          this.select_date,
        {},
        true
      );
      //console.log(data);
      this.medical_code_list = data.medical_code_list;
      this.time_list = data.time_list;
    },

    async calendarTdDelete(ym, date, row_index, cell_index, td_item) {
      const temp = date.split("///");
      const day = temp[0];
      const td_item_temp = td_item.split("|");

      this.select_date = ym + this.setFixDayCount(day);
      this.row_index = row_index;
      this.cell_index = cell_index;
      // this.schedule_seq = td_item_temp[td_item_temp.length - 1];
      this.schedule_seq = td_item_temp[3];

      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: "삭제",
        text: "해당 스케줄을 정말로 삭제하시겠습니까?",
        acceptText: "삭제",
        cancelText: "취소",
        accept: this.calendarTdDeleteSubmit,
      });
    },

    async calendarTdDeleteSubmit() {
      const { data } = await axiosClass.delete(
        "/api/patientCalendar/calendarSelect/" +
          this.patient_member_uid +
          "/" +
          this.select_date +
          "/" +
          this.schedule_seq,
        {regId : this.userUid},
        true
      );

      if (this.cell_index == 0) {
        this.calendar_data[this.row_index].Sun = data.data.SCHEDULE_DATA;
      } else if (this.cell_index == 1) {
        this.calendar_data[this.row_index].Mon = data.data.SCHEDULE_DATA;
      } else if (this.cell_index == 2) {
        this.calendar_data[this.row_index].Tue = data.data.SCHEDULE_DATA;
      } else if (this.cell_index == 3) {
        this.calendar_data[this.row_index].Wed = data.data.SCHEDULE_DATA;
      } else if (this.cell_index == 4) {
        this.calendar_data[this.row_index].Thu = data.data.SCHEDULE_DATA;
      } else if (this.cell_index == 5) {
        this.calendar_data[this.row_index].Fri = data.data.SCHEDULE_DATA;
      } else if (this.cell_index == 6) {
        this.calendar_data[this.row_index].Sat = data.data.SCHEDULE_DATA;
      }

      this.$vs.notify({
        title: "Success",
        text: "정상적으로 삭제되었습니다.",
        color: "danger",
        position: "top-right",
        iconPack: "feather",
        icon: "icon-check",
      });
      this.init(this.now_date);
    },
    onClickMemberView(type) {
      let uid = this.patient_member_uid;

      if (type == "patient") {
        this.$EventBus.$emit("memberView", uid);
      } else {
        this.$EventBus.$emit("memberCs", uid);
      }
    },
    async kakaoSend() {
      if (this.messageSelect == false) {
        this.$vs.notify({
          color: "danger",
          title: "오류",
          text: "발송 메시지를 선택해주세요.",
          position: "top-right",
          iconPack: "feather",
          icon: "icon-check",
        });
        return;
      } else if (
        this.messageResponder_1 == false &&
        this.messageResponder_2 == false &&
        this.messageResponder_3 == false
      ) {
        this.$vs.notify({
          color: "danger",
          title: "오류",
          text: "발송 대상자를 선택해주세요.",
          position: "top-right",
          iconPack: "feather",
          icon: "icon-check",
        });
        return;
      }
      const params = {
        schedule_date: this.kakao_date,
        messageSelect: this.messageSelect,
        messageResponder_1: this.messageResponder_1,
        messageResponder_2: this.messageResponder_2,
        messageResponder_3: this.messageResponder_3,
      };

      let data;
      try {
        const response = await axiosClass.post(
          "/api/patient/kakaoSend/" + this.patient_member_uid,
          params,
          true
        );
        data = response.data;
      } catch (error) {
        console.error('[kakaoSend] 카카오 전송 실패:', error);
        let errorMessage = '카카오 메시지 전송 중 오류가 발생했습니다. 환자 정보와 스케줄을 확인해주세요.';
        if (error.response && error.response.data && error.response.data.err_msg) {
          errorMessage = error.response.data.err_msg;
        }
        this.$vs.notify({
          color: "danger",
          title: "오류",
          text: errorMessage,
          position: "top-right",
          iconPack: "feather",
          icon: "icon-alert-circle",
        });
        return;
      }

      if (data.success == false) {
        this.$vs.notify({
          color: "danger",
          title: "오류",
          text: "금일 발송할 스케쥴이 존재하지 않습니다.",
          position: "top-right",
          iconPack: "feather",
          icon: "icon-check",
        });
      } else {
        this.$vs.notify({
          title: "Success",
          text: "정상적으로 발송되었습니다.",
          color: "success",
          position: "top-right",
          iconPack: "feather",
          icon: "icon-check",
        });
      }

      this.kakaoPopup = false;
    },

    kakaoClose() {
      this.kakaoPopup = false;
    },
    async clipCopyConfirm(ym, date) {
      // console.log(this.copy_schedule_seq + '///' + ymd + '///' + time);
      const temp = date.split("///");
      const day = temp[0];
      const time = temp[1].split("|")[1];
      this.copy_select_date = ym + this.setFixDayCount(day);
      
      if (this.copyChecked.length == 0) {
        this.$vs.notify({
          title: "확인",
          text: "복사할 컨텐츠를 선택해주세요.",
          color: "danger",
          position: "top-right",
          iconPack: "feather",
          icon: "icon-check",
        });
        return;
      }
      
      var scheduleId = temp[1].substring(0,5);
      this.selectedMedicalCode.id = scheduleId
      if(scheduleId == '01013' || scheduleId == '01014'){
        if(this.oxygenPoint < 1) {
            this.$vs.dialog({
                type: 'confirm',
                color: 'green',
                title: '확인',
                text: '포인트가 부족합니다. \n그래도 예약하시겠습니까?',
                position: 'center',
                acceptText: '네',
                cancelText: '취소',
                accept : () => {
                  this.checkOxygenCount (this.copy_select_date, time, 'copy');
                },
                cancel: function() {
                    return;
                }
              });
        } else {
          this.$vs.dialog({
            type: "confirm",
            color: "danger",
            title: "복사",
            text: "선택한 예약을 복사하시겠습니까?",
            acceptText: "복사",
            cancelText: "취소",
            accept: () => {
                  this.checkOxygenCount (this.copy_select_date, time, 'copy');
                },
            cancel: function () {
              return;
            },
          });
        } 
      } else {
        this.$vs.dialog({
            type: "confirm",
            color: "danger",
            title: "복사",
            text: "선택한 예약을 복사하시겠습니까?",
            acceptText: "복사",
            cancelText: "취소",
            accept: () => {
              this.DataCopy();
            },
            cancel: function () {
              return;
            },
          });
      }
      // document.getElementsByClassName('con-vs-chip').classList.remove('selectOn');
    },
    async DataCopy() {
      const jsonData = {
        copy_date: this.copyChecked,
        ymd: this.copy_select_date,
        uid: this.patient_member_uid,
        year_month: this.now_date,
      };
      
      const { data } = await axiosClass.post(
        "/api/patientCalendar/copyV4",
        jsonData,
        true
      );
      setTimeout(() => {
        this.$vs.loading.close("#schedule > .con-vs-loading");
      }, 100);

      this.calendar_data = data.calendar;

      // this.date_list = data.cure_data[0].YMD.split(',');
      // this.cure_data = data.cure_data;

      this.$vs.notify({
        title: "Success",
        text: "정상적으로 등록되었습니다.",
        color: "success",
        position: "top-right",
        iconPack: "feather",
        icon: "icon-check",
      });
      this.copyChecked = [];
      this.init(this.now_date);
      // const div = document.getElementsByClassName('con-vs-chip');
      // for (let i = 0; i < div.length; i++) {
      //     div[i].classList.remove('selectOn');
      // }
      // this.copy_schedule_seq = -1;
    },
    popupClose() {
      this.calendarWritePopup = false;
    },

    returnScheduleArr(item) {
      //console.log('item:' + item);
      if (item != undefined) {
        if (item == "") {
          return "";
        } else {
          //console.log('item:::', item);
          let temp = item.split("///");

          let arr = temp[1].split(",");
          
          // 시간 순으로 정렬 (temp[1]에 HHMM 형태 시간 정보가 있음)
          arr.sort((a, b) => {
            const timeA = a.split("|")[1] || "0000"; // 시간 정보 추출
            const timeB = b.split("|")[1] || "0000";
            return timeA.localeCompare(timeB);
          });
          
          //console.log(arr);
          return arr;
        }
      }
    },

    returnValueClass(item) {
      let temp = item.split("|");
      //console.log(temp);
      if(temp[0] ==  ''){
        return null;
      }
      else if(temp[0].substring(0, 2) == "05") {
        return "danger";
      } else if(temp[9] != '') {
        return "primary";
      } else if (temp[0].substring(0, 2) == "01" || temp[0].substring(0, 2) == "02") {
        // console.log('success');
        return "success";
      } else {
        return "warning";
      }
    },

    returnValueName(item) {
      //console.log("te=================>");
      let result = "";
      if (item == "") {
        result = "";
      } else {
        //console.log(item);
        let tt = item.split(",");
        for (let aa = 0; aa < tt.length; aa++) {
          let temp = tt[aa].split("|");
          //console.log(temp);
          // 시간 데이터에서 공백 제거 및 4자리로 패딩
          let timeStr = (temp[1] || "").replace(/\s/g, "");
          timeStr = timeStr.padStart(4, "0"); // 3자리인 경우 앞에 0 추가
          result +=
            "<br/>[" +
            timeStr.substring(0, 2) +
            ":" +
            timeStr.substring(2, 4) +
            "] " +
            temp[2];
          if (temp[7]) {
            result += "<br/>" + temp[7];
          }
          if (temp[8]) {
            const details = temp[8].split("@");
            let details_text = "";
            for (let a = 0; a < details.length; a++) {
              const detail_code = details[a];
              for (let b = 0; b < this.detailList.length; b++) {
                const medical_cd = this.detailList[b].MEDICAL_CD;
                if (medical_cd == temp[0]) {
                  const medical_detail_cd = this.detailList[b].MEDICAL_DETAIL_CD;
                  const medical_detail_nm = this.detailList[b].MEDICAL_DETAIL_NM;
                  if (medical_detail_cd == detail_code) {
                    if (details_text == "") details_text = medical_detail_nm;
                    else details_text += "," + medical_detail_nm;
                  }
                }
              }
            }
            result += "<br/>" + details_text;
          }
          if (temp[5]) {
            result += "<br/>" + temp[5] + " / " + temp[6];
          }
        }
      }
      return result;
    },

    returnDcYn(item) {
      if (item == "") {
        return "";
      } else {
        // console.log(item);
        let temp = item.split("|");
        return temp[4];
      }
    },

    calendarDataRemove() {
      this.calendarWritePopup = false;
      // console.log('OK');
    },
    //환자 메모 저장
    async patientMemoSave() {
      this.memo;
      const jsonData = {
        memo: this.memo,
      };
      // console.log(this.patient_member_uid);
      // console.log(jsonData);

      const { data } = await axiosClass.post(
        "/api/patientCalendar/patientMemoSave/" + this.patient_member_uid,
        jsonData,
        true
      );

      this.$vs.notify({
        title: "Success",
        text: "정상적으로 저장 되었습니다.",
        color: "success",
        position: "top-right",
        iconPack: "feather",
        icon: "icon-check",
      });
    },
    async calendarSave() {
      let errorMsg = "";
      if (this.medical_cd == "") {
        errorMsg = "스케줄 목록을 선택하여 주십시오.";
      }
      
      if(this.selectedMedicalCode == '01013' || this.selectedMedicalCode == '01014') {
        if(this.oxygenPoint < 1) {
            this.$vs.dialog({
                type: 'confirm',
                color: 'green',
                title: '확인',
                text: '포인트가 부족합니다. \n그래도 예약하시겠습니까?',
                position: 'center',
                acceptText: '네',
                cancelText: '취소',
                accept : () => {
                    this.checkOxygenCount (this.select_date, this.select_time, 'save');
                },
                cancel: function() {
                    return;
                }
            });
        } else {
          this.checkOxygenCount(this.select_date, this.select_time, 'save');
        }
      } else {
        this.saveLogic()
      }
    },
    async saveLogic () {
      let select_time = document.getElementById("select_time").value;
      if (isNaN(select_time) == false) {
        this.select_time = select_time;
      }
      const jsonData = {
        medical_cd: this.medical_cd,
        select_time: this.select_time,
      };
      //console.log(jsonData);
      const { data } = await axiosClass.post(
        "/api/patientCalendar/calendarSelect/" +
          this.patient_member_uid +
          "/" +
          this.select_date,
        jsonData,
        true
      );

      switch (data.err_code) {
        case "000":
          if (this.cell_index == 0) {
            this.calendar_data[this.row_index].Sun = data.data.SCHEDULE_DATA;
          } else if (this.cell_index == 1) {
            this.calendar_data[this.row_index].Mon = data.data.SCHEDULE_DATA;
          } else if (this.cell_index == 2) {
            this.calendar_data[this.row_index].Tue = data.data.SCHEDULE_DATA;
          } else if (this.cell_index == 3) {
            this.calendar_data[this.row_index].Wed = data.data.SCHEDULE_DATA;
          } else if (this.cell_index == 4) {
            this.calendar_data[this.row_index].Thu = data.data.SCHEDULE_DATA;
          } else if (this.cell_index == 5) {
            this.calendar_data[this.row_index].Fri = data.data.SCHEDULE_DATA;
          } else if (this.cell_index == 6) {
            this.calendar_data[this.row_index].Sat = data.data.SCHEDULE_DATA;
          }

          this.calendarWritePopup = false;

          this.$vs.notify({
            title: "Success",
            text: "정상적으로 등록되었습니다.",
            color: "success",
            position: "top-right",
            iconPack: "feather",
            icon: "icon-check",
          });

          break;
        default:
          this.$vs.notify({
            title: "Error",
            text: data.err_msg,
            color: "danger",
            position: "top-right",
            iconPack: "feather",
            icon: "icon-check",
          });
          break;
      }

      this.init(this.now_date);
    },
    async setCalendarData(year, month) {
      const setDate = new Date(year, month - 1, 1);
      const firstDay = setDate.getDate();

      //getDay(): Get the weekday as a number (0-6)
      //이번 달의 처음 요일을 구합니다.
      const firstDayName = setDate.getDay();

      const lastDay = new Date(
        this.today.getFullYear(),
        this.today.getMonth() + 1,
        0
      ).getDate();
      //지난 달의 마지막 날을 구합니다.
      const prevLastDay = new Date(
        this.today.getFullYear(),
        this.today.getMonth(),
        0
      ).getDate();

      //매월 일수가 달라지므로 이번 달 날짜 개수를 세기 위한 변수를 만들고 초기화 합니다.
      let startDayCount = 1;
      let lastDayCount = 1;

      this.calendar_temp = [];
      this.calendar_date = [];

      for (let i = 0; i < 6; i++) {
        for (let j = 0; j < 7; j++) {
          if (i == 0 && j < firstDayName) {
            let date = new Date(
              year,
              parseInt(month) - 1,
              prevLastDay - (firstDayName - 1) + j
            );
            let fullDate =
              String(date.getFullYear()) +
              String(this.setFixDayCount(date.getMonth())) +
              String(this.setFixDayCount(date.getDate()));
            this.calendar_temp.push({
              ymd: fullDate,
              day_of_week: j,
            });
          } else if (i == 0 && j == firstDayName) {
            this.calendar_temp.push({
              ymd: year + month + this.setFixDayCount(startDayCount++),
              day_of_week: j,
            });
          } else if (i == 0 && j > firstDayName) {
            this.calendar_temp.push({
              ymd: year + month + this.setFixDayCount(startDayCount++),
              day_of_week: j,
            });
          } else if (i > 0 && startDayCount <= lastDay) {
            this.calendar_temp.push({
              ymd: year + month + this.setFixDayCount(startDayCount++),
              day_of_week: j,
            });
          } else if (startDayCount > lastDay) {
            let date = new Date(year, parseInt(month) + 1, lastDayCount++);
            let fullDate =
              String(date.getFullYear()) +
              String(this.setFixDayCount(date.getMonth())) +
              String(this.setFixDayCount(date.getDate()));

            this.calendar_temp.push({
              ymd: fullDate,
              day_of_week: j,
            });
          }
        }
      }

      for (let i = 0; i < this.calendar_temp.length; i += 6) {
        this.calendar_date.push({
          sun: this.dateValueReturn(this.calendar_temp[i]),
          mon: this.dateValueReturn(this.calendar_temp[i + 1]),
          tue: this.dateValueReturn(this.calendar_temp[i + 2]),
          wed: this.dateValueReturn(this.calendar_temp[i + 3]),
          thu: this.dateValueReturn(this.calendar_temp[i + 4]),
          fri: this.dateValueReturn(this.calendar_temp[i + 5]),
          sat: this.dateValueReturn(this.calendar_temp[i + 6]),
        });
        i++;
      }

      // console.log(this.calendar_date);
    },
    dateValueReturn(value) {
      if (value == undefined) {
        return "";
      } else {
        return value.ymd;
      }
    },
    setFixDayCount(number) {
      let fixNum = "";
      if (number < 10) {
        fixNum = "0" + number;
      } else {
        fixNum = number;
      }
      return fixNum;
    },
    prevMonth() {
        const currentDate = moment(this.nowDate, 'YYYYMM');
        const prevMonth = currentDate.subtract(1, 'month');
        this.nowDate = prevMonth.format('YYYYMM');
        this.updateDate(this.nowDate);
    },
    nextMonth() {
        const currentDate = moment(this.nowDate, 'YYYYMM');
        const nextMonth = currentDate.add(1, 'month');
        this.nowDate = nextMonth.format('YYYYMM');
        this.updateDate(this.nowDate);
    },
    dayReturn(value) {
      // console.info('value:' + value);
      if (value == null || value == "") {
        return "";
      } else {
        let temp = value.split("///");
        // console.info('temp:' + temp);
        return temp[0];
      }
    },
    returnDay(value) {
      if (this.dayReturn(value) == this.now_day) {
        return "bg-now";
      } else {
        return "";
      }
    },
    returnHoliDay(value) {
      let temp = value.split("///");
      let returnVal = "";
      let returnClass = "";
      if (temp[0].length < 2) {
        returnVal= this.mergedCalendarData[0].YM + "0" + temp[0];
      } else {
        returnVal= this.mergedCalendarData[0].YM + temp[0];
      }
      for (let i = 0; i < this.holidayArr.length; i++) {
        if (this.holidayArr[i].LOC_DATE === returnVal && this.holidayArr[i].IS_HOLIDAY === 'N') {
          returnClass = "sat";
        } else if(this.holidayArr[i].LOC_DATE === returnVal && this.holidayArr[i].IS_HOLIDAY === 'Y') {
          returnClass = "sun";
        }
      }
      return returnClass;
    },
    return_schedule_seq(item) {
      let result = "";
      if (item == "") {
        result = "";
      } else {
        let temp = item.split("|");
        result = temp[3];
      }
      return result;
    },
    return_schedule_id(item) {
      let result = "";
      if (item == "") {
        result = "";
      } else {
        let temp = item.split("|");
        result = temp[0];
      }
      return result;
    },
    return_MedicalCode(item) {
      let result = "";
      if (item == "") {
        result = "";
      } else {
        let temp = item.split("|");
        result = temp[0];
      }
      return result;
    },
    async patientSearchBarList() {
      // this.$vs.loading({
      //     type: 'default',
      //     container: '#searchBar',
      //     background: 'rgba(0,0,0,0.1)',
      //     color: 'primary',
      //     scale: 1.5,
      // });
      const { data } = await axiosClass.get("/api/patientCalendar/patientSearchBarList/");

      //   setTimeout(() => {
      //       this.$vs.loading.close('#searchBar > .con-vs-loading');
      //   }, 100);

      this.options = [];

      var phoneString = [];
      var phoneStringEnd = [];
      var protectorPhoneString = [];
      var protectorPhoneString2 = [];
      if(data){
        for (let i = 0; i < data.length; i++) {
          var phoneStringArr =
            data[i].PATIENT_PHONE != null ? data[i].PATIENT_PHONE.split("-") : "";
          var protectorPhoneStringArr =
            data[i].PROTECTOR_PHONE != null ? data[i].PROTECTOR_PHONE.split("-") : "";
          var protectorPhoneStringArr2 =
            data[i].PROTECTOR_PHONE2 != null ? data[i].PROTECTOR_PHONE2.split("-") : "";

          phoneString[i] = phoneStringArr[0] + phoneStringArr[1] + phoneStringArr[2];
          protectorPhoneString[i] =
            protectorPhoneStringArr[0] +
            protectorPhoneStringArr[1] +
            protectorPhoneStringArr[2];
          protectorPhoneString2[i] =
            protectorPhoneStringArr2[0] +
            protectorPhoneStringArr2[1] +
            protectorPhoneStringArr2[2];
          phoneStringEnd[i] = phoneStringArr[2] == undefined ? "" : phoneStringArr[2];
        }
        for (let i = 0; i < data.length; i++) {
          this.options.push({
            patientId: data[i].PATIENT_UID,
            chartNo: data[i].CHART_NO,
            patientPhone: data[i].PATIENT_PHONE,
            label:
              data[i].CHART_NO +
              "/" +
              data[i].CD_STATUS_NAME +
              ":" +
              data[i].PATIENT_USERNAME +
              "(" +
              phoneStringEnd[i] +
              ")" 
              // +"\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0" +
              // "/" +
              // phoneString[i] +
              // "/" +
              // protectorPhoneString[i] +
              // "/" +
              // protectorPhoneString2[i],
          });
        }
      }
      

      this.patientList = this.options;

      for (let i = 0; i < this.patientList.length; i++) {
        if (
          this.patient_member_uid == this.patientList[i].patientId ||
          this.$route.params.uid == this.patientList[i].patientId
        ) {
          this.search = this.patientList[i].label;
          this.patient_member_uid = this.patientList[i].patientId;
        } else {
          this.patient_member_uid = this.$route.params.uid;
        }
      }

      if (
        this.patientList[0].patientId == null ||
        this.patientList[0].patientId == undefined
      ) {
        this.search = "로딩에 실패했습니다(F5를 눌러주세요)";
        this.patientList = [];
      }
    },

    applyPatientId(event) {
      this.patientList = [];
      if (event.patientUid != null || event.patientUid != undefined) {
        this.patient_member_uid = event.patientUid;
        this.$route.params.uid = event.patientUid;
      }

      //console.log("=======================");

      //console.log("=======================");
      this.init(this.now_date);
    },
    async popupOpen(medicalCode, day, time) {
      // let uid = this.patient_member_uid;
      // this.$EventBus.$emit('scheduleDoc', {uid, day, time});
      this.tab_options = [];
      this.viewDetailList = [];
      this.viewManagerList = [];
      this.scheduleSelectTime = "";
      this.scheduleMemo = "";
      this.memo_etc = "";
      this.dc = false;
      this.dcString = "";
      this.medicalManagers = "";
      this.medicalDetails = "";
      this.selectedMedicalCode = {};
      this.selectGubun = "";

      this.detailList = [];
      this.managerList = [];

      let tmpTitle = "";
      if (medicalCode == "01") {
        tmpTitle = "입원치료실 스케쥴 등록";
      } else if (medicalCode == "02") {
        tmpTitle = "원장님 스케쥴 등록";
        this.medicalCode = "02";
      } else {
        tmpTitle = "외래치료실 스케쥴 등록";
      }

      this.schedulePopupTitle = tmpTitle;

      const jsonData = {
        medicalCode: medicalCode,
      };
      
      const { data } = await axiosClass.get(
        "/api/patientCalendar/listScheduleTab/",
        jsonData,
        true
      );
      

      for (let i = 0; i < data.tab_option.length; i++) {
        this.tab_options.push({
          id: data.tab_option[i].MEDICAL_CD,
          label: data.tab_option[i].MEDICAL_NM,
          tabCode: data.tab_option[i].TAB_CODE,
        });
      }

      this.detailList = data.detailList;
      this.managerList = data.managerList;
      this.awaitTimeChk = false;
      this.awaitTime = '';
      this.schedulePopupActive = true;
    },
    selectMedicalDetail(value) {
      //console.log(this.selectedMedicalCode.id);
      this.viewDetailList = [];
      for (let i = 0; i < this.detailList.length; i++) {
        if (this.detailList[i].MEDICAL_CD == this.selectedMedicalCode.id) {
          this.viewDetailList.push(this.detailList[i]);
        }
      }

      this.viewManagerList = [];
      for (let i = 0; i < this.managerList.length; i++) {
        if (this.managerList[i].MEDICAL_CD == this.selectedMedicalCode.id) {
          this.viewManagerList.push(this.managerList[i]);
        }
      }
      //console.log(this.viewManagerList);
      this.medicalDetails = [];
      this.medicalManagers = [];
      // console.log('this.detailValue:::', this.medicalDetails);

      if(value) {
          if(value.id == '01014') {
              this.scheduleSelectTime = this.scheduleSelectTime.substring(0,2) + '30'
          } else if(value.id == '01013'){
              this.scheduleSelectTime = this.scheduleSelectTime.substring(0,2) + '00'
          }
      }
    },
    async scheduleSave() {
      let errorMsg = "";

      // 전각 숫자를 반각 숫자로 변환 (키보드 입력 문제 방지)
      if (this.scheduleSelectTime) {
        this.scheduleSelectTime = this.scheduleSelectTime
          .replace(/０/g, '0').replace(/１/g, '1').replace(/２/g, '2')
          .replace(/３/g, '3').replace(/４/g, '4').replace(/５/g, '5')
          .replace(/６/g, '6').replace(/７/g, '7').replace(/８/g, '8')
          .replace(/９/g, '9').replace(/\s/g, ''); // 공백도 제거
      }

      if (this.selectedMedicalCode.length < 0) {
        errorMsg = "치료실을 선택하여 주십시오.";
      } else if (this.scheduleSelectDate == null || this.scheduleSelectDate == "") {
        errorMsg = "날짜를 선택해주세요.";
      } else if (this.scheduleSelectTime == null || this.scheduleSelectTime == "") {
        errorMsg = "시간을 입력해주세요.";
      }
      // else if (this.medicalCode == '02') {
      //     if (this.medicalManagers == '') {
      //         errorMsg = '원장님을 선택하여 주십시오.';
      //     }
      // }
      
      if (this.patient_member_uid.length == 0) {
        errorMsg = "환자를 선택하여 주십시오.";
      } else if (this.viewDetailList.length > 0) {
        if (this.medicalDetails == "") {
          errorMsg = "스케줄을 선택하여 주십시오.";
        }
      }

      if (errorMsg != "") {
        this.$vs.notify({
          title: "Error",
          text: errorMsg,
          color: "danger",
          position: "top-right",
          iconPack: "feather",
          icon: "icon-check",
        });
        return;
      }
      if(this.selectedMedicalCode.id == '01013' || this.selectedMedicalCode.id == '01014') {
        if(this.oxygenPoint < 1) {
            this.$vs.dialog({
                type: 'confirm',
                color: 'green',
                title: '확인',
                text: '포인트가 부족합니다. \n그래도 예약하시겠습니까?',
                position: 'center',
                acceptText: '네',
                cancelText: '취소',
                accept : () => {
                    this.checkOxygenCount (this.scheduleSelectDate, this.scheduleSelectTime, 'save');
                },
                cancel: function() {
                    return;
                }
            });
        } else {
          this.checkOxygenCount (this.scheduleSelectDate, this.scheduleSelectTime, 'save');
        }
      } else {
        this.saveLogic2();
      }
    },
    async checkOxygenCount (date, time, divn) {
            var selectedDate = date.replace(/-/g, "");
            var selectedTime = time;
            const jsonData = {
                selectedDate: selectedDate, 
                selectedTime: selectedTime,
                selectedMedicalCode: this.selectedMedicalCode.id
            }
            console.log(jsonData)
            if(this.dc == false || this.awaitTime == '' || this.dc == '') {
              const { data } = await axiosClass.get('/api/cure/checkOxygenCount/'+ selectedDate +'/'+selectedTime +'/'+this.selectedMedicalCode.id, jsonData, true );
              setTimeout(() => {
                  this.$vs.loading.close('#schedule > .con-vs-loading');
              }, 100);
              
              let viewMsg = '';
              if(divn == 'save'){
                  viewMsg = '이미 해당 시간 정원이 찼습니다. \n그래도 저장하시겠습니까?'
              } else if(divn == 'copy') {
                  viewMsg = '이미 해당 시간 정원이 찼습니다. \n그래도 복사하시겠습니까?'
              }
              console.log(data)
              if(data.oxygenCount.COUNT >= 6) {
                  if(divn == 'save'){
                      this.$vs.dialog({
                          type: 'confirm',
                          color: 'green',
                          title: '확인',
                          text: viewMsg,
                          position: 'center',
                          acceptText: '네',
                          cancelText: '취소',
                          accept : () => {
                                  this.saveLogic2();
                          },
                          cancel: function() {
                              return;
                          }
                      });
                  } else if(divn == 'copy') {
                      this.$vs.dialog({
                          type: 'confirm',
                          color: 'green',
                          title: '확인',
                          text: viewMsg,
                          position: 'center',
                          acceptText: '네',
                          cancelText: '취소',
                          accept : () => {
                                  this.DataCopy();
                              
                          },
                          cancel: function() {
                              return;
                          }
                      });
                  }
              } else {
                if(divn == 'save'){
                  this.saveLogic2();
                } else if(divn == 'copy') {  
                  this.DataCopy();
                }       
              }
            } else {
              if(divn == 'save'){
                this.saveLogic2();
              } else if(divn == 'copy') {  
                this.DataCopy();
              }    
            }
        },
    async saveLogic2 (){
      let memo = document.getElementById("scheduleMemo").value;
      let scheduleSelectTime = document.getElementById("scheduleSelectTime").value;

      if (isNaN(scheduleSelectTime) == false) {
        this.scheduleSelectTime = scheduleSelectTime;
      }
      let dcString = "";
      if (this.dc == false) {
        dcString = "N";
        this.dc_memo = "";
      } else {
        dcString = "Y";
      }

      let medicalDetails = "";
      
      if (this.selectedMedicalCode.id.substring(0, 2) == "02") {
        medicalDetails = "";
      } else {
        medicalDetails = this.medicalDetails.join();
      }
      let week_sum = 0;
      let jsonData = {};

      jsonData = {
        patientId: this.patient_member_uid,
        selectedMedicalCode: this.selectedMedicalCode.id,
        scheduleSelectDate: this.scheduleSelectDate,
        scheduleSelectTime: scheduleSelectTime,
        tab_medical_cd: this.selectedMedicalCode.tabCode,
        schedule_seq: this.schedule_seq,
        memo: memo,
        memo_etc: this.memo_etc,
        dc: dcString,
        selectGubun: this.selectGubun,
        dc_memo: this.dc_memo,
        medicalDetails: medicalDetails,
        medicalManagers: this.medicalManagers,

        authCheck: this.autoCheck || null,
        schdule_endYN: this.schdule_endYN || "N",
        schedule_end:
          this.schedule_end != "" ? this.customFormatter(this.schedule_end) : "",
        schedule_week: week_sum || 0,
        schedule_gubun_number: this.schedule_gubun_number || 1,
        schedule_gubun_type: this.schedule_gubun_type || 0,
        schedule_gubun_days: this.schedule_gubun_days || 0,
        awaitTime : this.awaitTime + '',
        prevScheduleData : this.prevScheduleData
      };

      this.$vs.loading({
        type: "default",
        container: "#scheduleCalendar",
        background: "rgba(0,0,0,0.1)",
        color: "primary",
        scale: 1.5,
      });

      const { data } = await axiosClass.post(
        "/api/patientCalendar/scheduleSave",
        jsonData,
        true
      );

      setTimeout(() => {
        this.$vs.loading.close("#scheduleCalendar > .con-vs-loading");
      }, 100);

      this.schedulePopupActive = false;

      this.$vs.notify({
        title: "Success",
        text: "정상적으로 등록되었습니다.",
        color: "success",
        position: "top-right",
        iconPack: "feather",
        icon: "icon-check",
      });

      this.init(this.now_date);
    },
    customFormatter(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    popupClose() {
      this.schedulePopupActive = false;
      this.viewDetailList = [];
      this.viewManagerList = [];
      this.scheduleSelectDate = "";
      this.scheduleSelectTime = "";
      this.scheduleMemo = "";
      this.dc = false;
      this.dcString = "";
      this.medicalManagers = "";
      this.medicalDetails = "";
      this.selectedMedicalCode = {};
      this.selectGubun = "";
      this.medicalCode = "";
      this.awaitTimeChk = false;
      this.awaitTime = '';
    },
    async modifyPopupOpen(schedule_seq, medicalCode) {
      //console.log(schedule_seq);

      let tmpTitle = "";
      if (medicalCode.substring(0, 2) == "01") {
        tmpTitle = "입원치료실 스케쥴 등록";
        this.medicalCode = "01";
      } else if (medicalCode.substring(0, 2) == "03") {
        tmpTitle = "외래치료실 스케쥴 등록";
        this.medicalCode = "03";
      } else {
        tmpTitle = "원장님 스케쥴 등록";
        this.medicalCode = "02";
      }

      this.schedulePopupTitle = tmpTitle;

      this.schedule_seq = parseInt(schedule_seq);
      this.tab_options = [];
      this.detailList = [];
      this.managerList = [];

      const jsonData = {
        medicalCode: medicalCode.substring(0, 2),
      };
      const { data } = await axiosClass.get(
        "/api/patientCalendar/listScheduleTab/",
        jsonData,
        true
      );
      
      
      for (let i = 0; i < data.tab_option.length; i++) {
        this.tab_options.push({
          id: data.tab_option[i].MEDICAL_CD,
          label: data.tab_option[i].MEDICAL_NM,
          tabCode: data.tab_option[i].TAB_CODE,
        });
      }

      this.detailList = data.detailList;
      this.managerList = data.managerList;

      this.$vs.loading({
        type: "default",
        container: "#schedulePopup",
        background: "rgba(0,0,0,0.1)",
        color: "primary",
        scale: 1.5,
      });

      const response = await axiosClass.get(
        "/api/patientCalendar/scheduleDetail/" + schedule_seq,
        true
      );
      const data2 = response.data.data;
      this.prevScheduleData = data2;

      setTimeout(() => {
        this.$vs.loading.close("#schedulePopup > .con-vs-loading");
      }, 100);

      //console.log(data2.data);

      this.selectedMedicalCode = data2.MEDICAL_CODE;
      for (let i = 0; i < this.tab_options.length; i++) {
        if (this.tab_options[i].id == data2.MEDICAL_CODE) {
          this.selectedMedicalCode = this.tab_options[i];
        }
      }
      this.dc_memo = data2.DC_MEMO;
      if (data2.DC == "" || data2.DC == "N") {
        this.dc = false;
      } else {
        this.dc = true;
      }

      this.scheduleMemo = data2.MEMO;
      this.memo_etc = data2.MEMO_ETC;
      this.selectGubun = data2.INSERT_GUBUN;

      if (data2.DC == "Y") {
        this.dc = true;
      } else {
        this.dc = false;
        this.dc_memo = "";
      }

      this.dc_memo = data2.DC_MEMO;
      this.awaitTimeChk = data2.AWAIT_TIME == '' ? false : true;
      this.awaitTime = data2.AWAIT_TIME;
      this.selectMedicalDetail();

      this.scheduleSelectDate =
        data2.YMD_STRING.substring(0, 4) +
        "-" +
        data2.YMD_STRING.substring(4, 6) +
        "-" +
        data2.YMD_STRING.substring(6, 8);
      this.scheduleSelectTime = data2.REAL_TIME_STRING;

      if (data2.MEDICAL_DETAILS == null) {
        this.medicalDetails = "";
      } else {
        if (data2.MEDICAL_DETAILS != "") {
          this.medicalDetails = data2.MEDICAL_DETAILS.split(",");
        }
      }
      if (
        data2.MEDICAL_MANAGERS != null ||
        data2.MEDICAL_MANAGERS != undefined ||
        data2.MEDICAL_MANAGERS != ""
      ) {
        this.medicalManagers = data2.MEDICAL_MANAGERS;
      }
      this.schedulePopupActive = true;
    },
    applyDateOnPopup(itemDate, day) {
      let itemYM = itemDate.YM;
      let addDate = day;

      if (addDate.length < 2) {
        addDate = "0" + addDate;
      }

      let tmpDate = moment(itemYM + addDate).format("YYYY-MM-DD");
      this.scheduleSelectDate = tmpDate;
      this.now_date = itemYM;
    },
    checkEtcScheduleDate(distinguishString, dayString) {
      let monthString = this.now_date.substring(4, 6);

      if (dayString != "" && distinguishString == "f/u" && this.followUpDate != undefined) {
        if (
          this.followUpDate.substring(8, 10) == dayString &&
          this.followUpDate.substring(5, 7) == monthString
        ) {
          //console.log(this.followUpDate);
          return true;
        } else {
          return false;
        }
      } else if (dayString != "" && distinguishString == "inspection" && this.inspectionDate != undefined) {
        if (
          this.inspectionDate.substring(8, 10) == dayString &&
          this.inspectionDate.substring(5, 7) == monthString
        ) {
          return true;
        } else {
          return false;
        }
      } else if (dayString != "" && distinguishString == "indemStdt" && this.indemStdt != undefined) {
        if (
          this.indemStdt.substring(8, 10) == dayString &&
          this.indemStdt.substring(5, 7) == monthString
        ) {
          return true;
        } else {
          return false;
        }
      } else if (dayString != "" && distinguishString == "indemEnddt" && this.indemEnddt != undefined) {
        if (
          this.indemEnddt.substring(8, 10) == dayString &&
          this.indemEnddt.substring(5, 7) == monthString
        ) {
          return true;
        } else {
          return false;
        }
      }
    },
    etcScheduleColor(distinguishString) {
      if (distinguishString == "f/u") {
        return "rgb(255,102,102)";
      } else if (distinguishString == "inspection") {
        return "rgb(204,102,153)";
      } else if (distinguishString == "indemStdt") {
        return "rgb(051,102,153)";
      } else if (distinguishString == "indemEnddt") {
        return "rgb(051,153,051)";
      }
    },
    gubunChange(event) {
      this.selectGubunIndex = 0;
      if (this.selectGubun == "") {
        this.memo = "";
        this.select_user = "";
        this.selectGubunIndex = event.target.indexOf();
      } else if (this.selectGubun == "1" || this.selectGubun == "2") {
        this.memo = "";
        this.selectGubunIndex = event.target.indexOf();
      } else if (this.selectGubun == "99") {
        this.select_user = "";
        this.selectGubunIndex = event.target.indexOf();
      }

      if (this.selectGubun != "97") {
        this.autoCheck = null;
        this.schdule_endYN = "N";
        this.schedule_end = "";
        this.schedule_week = [];
        this.schedule_gubun_type = 0;
        this.schedule_gubun_number = 1;
        this.schedule_gubun_days = 0;
        this.selectGubunIndex = event.target.indexOf();
      }
    },
    async makeExcelFile() {
      if (this.$route.params.uid != null && this.$route.params.uid != undefined) {
        this.patient_member_uid = this.$route.params.uid;
      }
      const jsonData = {
        year_month: this.now_date,
        uid: this.patient_member_uid,
      };
      
      const { data } = await axiosClass.get(
        "/api/patientCalendar/excelData/" + this.patient_member_uid,
        jsonData,
        true
      );

      const workBook = Xlsx.utils.book_new();
      const workSheet = Xlsx.utils.json_to_sheet(data.calendar);
      Xlsx.utils.book_append_sheet(workBook, workSheet, this.now_date);
      Xlsx.writeFile(workBook, this.patientUsername + ' 환자스케쥴.xlsx');
    },
    printCalendar () {
      // 캘린더 테이블만 가져오기 (날짜 선택기, 버튼 제외)
      const calendarTable = document.querySelector('#printArea table.calendar');
      if (!calendarTable) {
        alert('캘린더를 찾을 수 없습니다.');
        return;
      }
      const tableContent = calendarTable.outerHTML;
      const patientInfo = this.medicalRoomNumberNm + ') ' + this.patientUsername;
      const dateInfo = this.now_date ? this.now_date.substring(0, 4) + '년 ' + this.now_date.substring(4, 6) + '월' : '';

      const printWindow = window.open('', '_blank', 'width=1200,height=800');
      printWindow.document.write(
        '<!DOCTYPE html>' +
        '<html>' +
        '<head>' +
        '<title>환자스케줄 - ' + this.patientUsername + '</title>' +
        '<style>' +
        '@page { size: A4 landscape; margin: 10mm; }' +
        '* { box-sizing: border-box; }' +
        'body { font-family: "Malgun Gothic", sans-serif; margin: 0; padding: 10px; -webkit-print-color-adjust: exact; print-color-adjust: exact; }' +
        '.print-header { text-align: center; margin-bottom: 15px; }' +
        '.patient-name { font-size: 1.5rem; font-weight: bold; }' +
        '.date-info { font-size: 1.2rem; color: #333; margin-top: 5px; }' +
        'table { width: 100%; border-collapse: collapse; table-layout: fixed; }' +
        'thead { display: table-header-group; }' +
        'tbody { display: table-row-group; }' +
        'tr { break-inside: avoid; page-break-inside: avoid; }' +
        'th, td { border: 1px solid #ddd; padding: 8px; vertical-align: top; word-wrap: break-word; }' +
        'th { background-color: #f5f5f5; text-align: center; font-size: 1rem; }' +
        '.day { display: flex; justify-content: flex-start; padding: 8px; }' +
        '.days_left { font-size: 1.5rem; font-weight: bold; }' +
        '.days_right, .n-content { display: none !important; }' +
        '.dayContents { min-height: 90px; padding: 5px; }' +
        // Vuesax vs-chip 스타일
        '.con-vs-chip { display: flex; align-items: center; justify-content: flex-start; padding: 8px 12px; margin: 4px 0; border-radius: 20px; min-height: 36px; color: white; font-size: 0.9rem; break-inside: avoid; page-break-inside: avoid; }' +
        '.con-vs-chip.vs-chip-primary { background-color: #015666 !important; }' +
        '.con-vs-chip.vs-chip-success { background-color: #28C76F !important; }' +
        '.con-vs-chip.vs-chip-danger { background-color: #EA5455 !important; }' +
        '.con-vs-chip.vs-chip-warning { background-color: #FF9F43 !important; }' +
        '.vs-chip--text { flex: 1; color: white; }' +
        '.vs-chip--text span { color: white; }' +
        // 체크박스 스타일 (인쇄용)
        '.con-vs-chip input[type="checkbox"] { width: 14px; height: 14px; margin-right: 8px; accent-color: white; }' +
        // 아이콘 및 불필요 요소 숨김
        '.con-vs-chip a, .con-vs-chip .vs-icon, .con-vs-chip i, [class*="icon-edit"], [class*="icon-x"] { display: none !important; }' +
        '.sun { color: red; }' +
        '.table_header { font-weight: bold; padding: 10px; }' +
        'button, .vs-button, .mx-datepicker, .mx-input { display: none !important; }' +
        '.w-full { width: 100%; }' +
        '.v-content { width: 100%; }' +
        '</style>' +
        '</head>' +
        '<body>' +
        '<div class="print-header">' +
        '<div class="patient-name">' + patientInfo + '</div>' +
        '<div class="date-info">' + dateInfo + '</div>' +
        '</div>' +
        tableContent +
        '</body>' +
        '</html>'
      );
      printWindow.document.close();

      // 문서 로드 후 인쇄
      printWindow.onload = function() {
        printWindow.print();
      };
    },
    setAwaitTime() {
        if(this.awaitTimeChk == true) {
            this.awaitTime = moment().format('YYYY-MM-DD HH:mm:ss');
        } else {
            this.awaitTime = '';
        }
        
    },
    mergeCalendarData(calendar_data, calendar_data2) {
        let mergedData = [];

        calendar_data.forEach((item1, index) => {
            let item2 = calendar_data2[index];
            let mergedItem = { ...item1 };

            mergedItem.Sun = this.mergeDays(item1.Sun, item2.Sun);
            mergedItem.Mon = this.mergeDays(item1.Mon, item2.Mon);
            mergedItem.Tue = this.mergeDays(item1.Tue, item2.Tue);
            mergedItem.Wed = this.mergeDays(item1.Wed, item2.Wed);
            mergedItem.Thu = this.mergeDays(item1.Thu, item2.Thu);
            mergedItem.Fri = this.mergeDays(item1.Fri, item2.Fri);
            mergedItem.Sat = this.mergeDays(item1.Sat, item2.Sat);
            
            mergedData.push(mergedItem);
        });
        return mergedData;
    },
    mergeDays(day1, day2) {
      if (day1 == null || day2 == null) return "";
      
      if (!day1) return day1;
      const day1Parts = day1.split('///');
      const day2Parts = day2.split('///');

      if (day1Parts[0] === day2Parts[0]) {
          if(day2Parts[1] !== ''){
            return `${day1},${day2Parts[1]}`;
          } else {
            return `${day1}`;
          }  
      } 
      
    },
    async onClickKakao() {
      let params = {};
      this.kakao_date = moment().format("YYYY-MM-DD");
      this.kakaoPopup = true;
      this.messageSelect = "";
      this.messageResponder_1 = false;
      this.messageResponder_2 = false;
      this.messageResponder_3 = false;
    },
    async searchPatient (value) {
        this.patientList = [];

        if(!value || value.trim() === '') return;

        const trimmedValue = value.trim();
        const digitsOnly = trimmedValue.replace(/[^0-9]/g, '');
        const isPhoneSearch = /^\d+$/.test(trimmedValue.replace(/-/g, ''));

        let searchValue = trimmedValue;
        // 숫자 3자리 이하: 차트번호만 검색 (전화번호 제외)
        // 숫자 4자리 이상: 차트번호 + 전화번호 검색
        let phoneSearchFlag = 'Y';

        if (isPhoneSearch && digitsOnly.length <= 3) {
            phoneSearchFlag = 'N';
        }

        // 숫자 5자리 이상: 하이픈 포맷팅하여 앞에서부터 검색
        if (isPhoneSearch && digitsOnly.length >= 5) {
            if (/^01[016789]/.test(digitsOnly)) {
                // 010, 011 등 모바일 번호 전체 입력
                const prefix = digitsOnly.substring(0, 3);
                const mid = digitsOnly.substring(3, 7);
                const last = digitsOnly.substring(7);
                searchValue = prefix + '-' + mid + (last ? '-' + last : '');
            } else {
                // 중간+끝자리 입력 (예: 57204 → 5720-4)
                searchValue = digitsOnly.substring(0, 4) + '-' + digitsOnly.substring(4);
            }
        }

        let params = {
            search_name : searchValue,
            phone_search : phoneSearchFlag
        }

        const { data } = await axiosClass.get(
            "/api/patient/search_patientList",
            params,
            true
        );
        for (let i = 0; i < data.data.length; i++) {
            const phone = data.data[i].PATIENT_PHONE || '';
            this.patientList.push({
                id: data.data[i].PATIENT_UID,
                patientPhone : phone,
                patientName : data.data[i].PATIENT_USERNAME,
                patientUid : data.data[i].PATIENT_UID,
                oxygenPoint : data.data[i].OXYGEN_POINT || 0,
                label: (data.data[i].MEDICAL_ROOM_NM != '' ? data.data[i].MEDICAL_ROOM_NM + '-' + data.data[i].MEDICAL_ROOM_NUMBER_NM + ' : ' : '') + data.data[i].CHART_NO + '/' + data.data[i].PATIENT_USERNAME + '('+ phone.substr(9,4) + ')',
            });
        }

    },
    updateDate(date) {
      this.nowDate = date;
      this.now_date = date;
      this.init(date);
    },
    
    // 다중 복사 관련 메서드들
    openMultiCopyModal() {
      console.log('openMultiCopyModal called, copyChecked:', this.copyChecked);
      
      if (this.copyChecked.length === 0) {
        this.$vs.notify({
          title: '확인',
          text: '복사할 스케줄을 선택해주세요.',
          color: 'danger',
          position: 'top-right',
          iconPack: 'feather',
          icon: 'icon-check',
        });
        return;
      }
      
      this.multiCopyChecked = [];
      this.targetDates = [{ date: '', time: '' }];
      this.multiCopyPopup = true;
    },

    getSelectedSchedulesForMultiCopy() {
      const selectedSchedules = [];
      
      console.log('copyChecked:', this.copyChecked);
      
      // copyChecked에서 선택된 스케줄들을 찾아서 반환
      this.copyChecked.forEach(scheduleSeq => {
        let foundSchedule = null;
        
        // 모든 날짜의 스케줄을 검색해서 해당 SEQ를 가진 스케줄 찾기
        this.mergedCalendarData.forEach(weekData => {
          ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].forEach(day => {
            const daySchedules = this.returnScheduleArr(weekData[day]);
            if (daySchedules && !foundSchedule) {
              daySchedules.forEach(schedule => {
                if (this.return_schedule_seq(schedule) == scheduleSeq) {
                  // 스케줄 데이터 파싱: item.split(",")[0].split("|")
                  const scheduleItems = schedule.split(",");
                  if (scheduleItems.length > 0) {
                    const firstItem = scheduleItems[0].split("|");
                    console.log('Schedule data parsed:', firstItem);
                    
                    foundSchedule = {
                      seq: scheduleSeq,
                      time: firstItem[1] || '',
                      medical: firstItem[2] || '',
                      room: '',
                      patient: this.patientUsername || '',
                      original: schedule
                    };
                  }
                }
              });
            }
          });
        });
        
        if (foundSchedule) {
          selectedSchedules.push(foundSchedule);
        } else {
          // 찾지 못한 경우 기본값으로 추가
          selectedSchedules.push({
            seq: scheduleSeq,
            time: '',
            medical: '',
            room: '',
            patient: this.patientUsername || '',
            original: null
          });
        }
      });
      
      console.log('selectedSchedules:', selectedSchedules);
      return selectedSchedules;
    },

    formatScheduleTime(timeStr) {
      if (!timeStr) return '';
      return timeStr.substring(0, 2) + ':' + timeStr.substring(2, 4);
    },

    addTargetDate() {
      this.targetDates.push({ date: '', time: '' });
    },

    removeTargetDate(index) {
      this.targetDates.splice(index, 1);
    },

    closeMultiCopyModal() {
      this.multiCopyPopup = false;
      this.multiCopyChecked = [];
      this.targetDates = [];
    },

    customFormatter(date) {
      return moment(date).format('YYYY-MM-DD');
    },

    async executeMultiCopy() {
      if (this.multiCopyChecked.length === 0) {
        this.$vs.notify({
          title: '확인',
          text: '복사할 스케줄을 선택해주세요.',
          color: 'danger',
          position: 'top-right',
          iconPack: 'feather',
          icon: 'icon-check',
        });
        return;
      }

      // 날짜/시간 입력 검증
      const hasEmptyFields = this.targetDates.some(t => {
        const hasDate = t.date && (typeof t.date === 'string' || t.date instanceof Date);
        const hasTime = t.time && t.time.trim() !== '';
        return !hasDate || !hasTime;
      });

      if (this.targetDates.length === 0 || hasEmptyFields) {
        this.$vs.notify({
          title: '확인',
          text: '복사할 날짜와 시간을 모두 입력해주세요.',
          color: 'danger',
          position: 'top-right',
          iconPack: 'feather',
          icon: 'icon-check',
        });
        return;
      }

      this.$vs.dialog({
        type: 'confirm',
        color: 'primary',
        title: '다중 복사',
        text: `선택한 스케줄을 ${this.targetDates.length}개 날짜/시간으로 복사하시겠습니까?`,
        acceptText: '복사',
        cancelText: '취소',
        accept: () => {
          this.executeMultiDataCopy();
        }
      });
    },

    async executeMultiDataCopy() {
      const targetDatesFormatted = this.targetDates.map(target => {
        let dateString = target.date;
        if (target.date instanceof Date) {
          dateString = this.customFormatter(target.date);
        }
        return {
          date: dateString.replace(/-/g, ''),
          time: target.time
        };
      });

      const jsonData = {
        source_schedule_seqs: this.multiCopyChecked,
        target_dates_times: targetDatesFormatted,
        patient_member_uid: this.patient_member_uid,
        year_month: this.now_date
      };

      this.$vs.loading({
        type: 'default',
        container: '#scheduleRootDiv',
        background: 'rgba(0,0,0,0.1)',
        color: 'primary',
        scale: 1.5,
      });

      try {
        const { data } = await axiosClass.post('/api/patientCalendar/multiCopy', jsonData, true);
        
        setTimeout(() => {
          this.$vs.loading.close('#scheduleRootDiv > .con-vs-loading');
        }, 100);

        this.closeMultiCopyModal();
        
        // 데이터 새로고침
        this.init(this.now_date);

        this.$vs.notify({
          title: 'Success',
          text: '다중 복사가 완료되었습니다.',
          color: 'success',
          position: 'top-right',
          iconPack: 'feather',
          icon: 'icon-check',
        });
      } catch (error) {
        setTimeout(() => {
          this.$vs.loading.close('#scheduleRootDiv > .con-vs-loading');
        }, 100);

        this.$vs.notify({
          title: 'Error',
          text: '다중 복사 중 오류가 발생했습니다.',
          color: 'danger',
          position: 'top-right',
          iconPack: 'feather',
          icon: 'icon-x',
        });
      }
    }
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
    this.patient_member_uid = this.$route.params.uid;
    this.kakao_date = moment().format("YYYY-MM-DD");
    this.tab_sum = store.getters.getTABSUM;
    //this.patientSearchBarList();
    this.init("");
    // this.calendar('');

    EventBus.$on("remoteListRefresh", async () => {
      //await this.patientSearchBarList();
      await this.init("");
    });
    EventBus.$on("remoteListCsRefresh", async () => {
      //await this.patientSearchBarList();
      await this.init("");
    });
    EventBus.$on("remoteScheduleRefresh", async () => {
      this.init("");
    });
    this.$nextTick(() => {
        const inputElement = this.$refs.searchInput.$el.querySelector("input");
        if (inputElement) {
          // 이벤트 핸들러를 저장하여 나중에 제거할 수 있도록 함
          this.searchKeyupHandler = (event) => {
              if (event.key === "Enter") {
                this.searchPatient(inputElement.value);
              }
          };
          inputElement.addEventListener("keyup", this.searchKeyupHandler);
        }
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
    // keyup 이벤트 리스너 제거
    const inputElement = this.$refs.searchInput && this.$refs.searchInput.$el ? this.$refs.searchInput.$el.querySelector("input") : null;
    if (inputElement && this.searchKeyupHandler) {
      inputElement.removeEventListener("keyup", this.searchKeyupHandler);
    }
  },
};
</script>

<style>
body {

width: 800%;

height: 100%;

margin: 0;

padding: 0;


} 

.paper {


border-radius: 5px;

background: #fff;



}

.content {

padding: 0;

}

@media print {
    @page {
      size: A4 landscape; /* A4 가로 방향 설정 */
      margin: 10mm; /* 페이지 여백 설정 */
      background-color: white;
    }
    body {
      -webkit-print-color-adjust: exact; /* 색상 조정 */
      zoom: 0.75; /* 화면 축소 */
      background-color: white;
    }
    /* printing-calendar 클래스 기반 프린트 스타일 */
    /* 기존 visibility 방식 유지 (printArea 내용만 보이게) */
    body.printing-calendar * {
      visibility: hidden;
    }
    body.printing-calendar #printArea,
    body.printing-calendar #printArea * {
      visibility: visible;
    }

    /* 추가: 사이드바, 네비바는 display: none으로 공간도 제거 */
    body.printing-calendar .vs-sidebar-primary,
    body.printing-calendar .vs-sidebar,
    body.printing-calendar .v-nav-menu,
    body.printing-calendar .the-navbar,
    body.printing-calendar [class*="navbar"],
    body.printing-calendar .vx-navbar-wrapper {
      display: none !important;
    }

    /* 상위 컨테이너 여백/패딩 제거 */
    body.printing-calendar .layout--main,
    body.printing-calendar #content-area,
    body.printing-calendar .content-wrapper,
    body.printing-calendar .router-view,
    body.printing-calendar .router-content,
    body.printing-calendar .content-area__content {
      margin: 0 !important;
      padding: 0 !important;
      margin-top: 0 !important;
      padding-top: 0 !important;
      margin-left: 0 !important;
      padding-left: 0 !important;
    }

    /* printArea를 최상단에 배치 */
    body.printing-calendar #printArea {
      position: fixed !important;
      left: 0 !important;
      top: 0 !important;
      width: 100% !important;
    }

    /* 날짜 표시 보장 */
    body.printing-calendar .days_left {
      visibility: visible !important;
      display: block !important;
      flex-shrink: 0 !important;
      min-width: 30px !important;
    }
    body.printing-calendar .printPatientInfo {
      display: inline !important;
      visibility: visible !important;
    }
    .content {
      width: 100%;
      overflow: visible; /* 스크롤 해제 */
      /* background-color: white; */
    }
    table {
      width: 100%;
      table-layout: fixed; /* 테이블 레이아웃 고정 */
      border-collapse: collapse; /* 테이블 경계선 합치기 */
      background-color: white;
    }
    th, td {
      padding: 0px; /* 셀 여백 설정 */
      word-wrap: break-word; /* 텍스트 줄바꿈 설정 */
      overflow: visible !important; /* 셀 내 스크롤 해제 */
      white-space: normal; /* 텍스트 줄 바꿈 설정 */
      background-color: white !important;
    }
    .n-content {
      display: none !important; /* 인쇄 시 n-content 클래스 숨기기 */
      background-color: white;
    }
    .day, .dayContents {
      max-width: 100%;
      background-color: white;
    }
    .day {
      display: flex;
      justify-content: space-between;
    }
    tr {
      break-inside: avoid; /* 행 단위로 페이지 내에서 분리되지 않도록 설정 */
      background-color: white;
    }
    .v-content {
      margin: 0;
      /* background-color: white !important; 배경색 흰색 */
      color: white !important; /* 글씨색 검은색 */
      font-size: 1em !important; /* 글씨 크기 2배 */
      font-weight: bold !important; /* 글씨 굵게 */
      border: 1px solid black;
      border-radius: 10%;
    }
    .vs-chip-primary {
      /* 인쇄 시 색상이 제대로 나오도록 강제 */
      background-color: #015666; /* primary 색상 예시 */
    }
    .vs-chip-success {
      background-color: #28C76F; /* success 색상 예시 */
    }
    .vs-chip-danger {
      background-color: #EA5455; /* danger 색상 예시 */
    }
    .vs-chip-warning {
      background-color: #FF9F43; /* warning 색상 예시 */
    }
}
.day {
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.days_left {
  width: 30%;
  flex-shrink: 0;
  min-width: 25px;
  flex-direction: row;
  justify-content: center;
  font-size: 1.4rem;
  padding-left: 5px;
}

.days_right {
  width: 200px;
  text-align: right;
  flex-direction: row;
  padding-right: 5px;
}

.sun {
  color: red;
}
.sat {
  color: blue;
}

.dayContents {
  padding: 2px;
  overflow: auto;
  min-height: 100px;
}

.calendar tr td {
  vertical-align: top;
}

.calendar tr td:hover {
  background-color: rgba(241, 241, 241, 0.2);
  cursor: pointer;
}

.includeIcon {
  display: initial;
}

.con-vs-chip {
  min-height: 40px;
}

.vs-chip—text {
  font-size: 1.1rem;
}
.vs-chip--text span {
  min-width: 120px;
  margin: 5px;
}

.plan_text {
  background-color: #f1f1f1;
  height: 100px !important;
  padding: 10px;
  font-size: 12px;
}
.bg-now {
  background-color: rgba(156, 182, 129, 0.2);
}

.mx-datepicker-popup {
  z-index: 90000000 !important;
}
.activeMenu {
  border-color: #015666;
}

.activeMenu2 {
  border-bottom-width: 3px !important;
  border-color: #015666;
}

.tb_box {
  height: 630px;
  overflow: auto;
}
input::placeholder {
  color: rgb(185, 185, 185);
}
/* .divFixed {
    position: fixed;
    top: 300px;
    index: 999;
} */

#memberPopup .vs-popup {
  width: 1200px !important;
}

#csPopup .vs-popup {
  width: 1200px !important;
}

/* 다중 복사 관련 스타일 */
.multi-copy-popup .vs-popup {
  width: 1200px !important;
  max-width: 95vw !important;
  height: 800px !important;
  max-height: 90vh !important;
}

.multi-copy-popup .vs-popup--content {
  height: calc(100% - 50px) !important;
  overflow: hidden !important;
}

.multi-copy-popup .con-vs-popup {
  max-width: 1200px;
  min-height: 800px;
}

.multi-copy-container {
  padding: 20px;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.multi-copy-schedule-section {
  flex-shrink: 0;
  margin-bottom: 20px;
}

.multi-copy-schedule-section h5 {
  margin-bottom: 10px;
}

.multi-copy-dates-section {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
}

.multi-copy-dates-section h5 {
  flex-shrink: 0;
  margin-bottom: 10px;
}

.target-dates-container {
  flex: 1;
  overflow-y: auto;
  padding: 10px;
  background-color: #fafafa;
  border: 1px solid #eee;
  border-radius: 8px;
}

.multi-copy-buttons {
  flex-shrink: 0;
  display: flex;
  justify-content: flex-end;
  padding-top: 20px;
  margin-top: 20px;
  border-top: 1px solid #eee;
}

.schedule-item {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 4px;
}

.target-date-item {
  background-color: #fff;
  border: 1px solid #dee2e6;
  border-radius: 4px;
}

.time-input {
  width: 100px;
  text-align: center;
}
</style>
